(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6514],{

/***/ 13502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82269);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core_createConnector_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47906);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/**
 * connectCurrentRefinements connector provides the logic to build a widget that will
 * give the user the ability to remove all or some of the filters that were
 * set.
 * @name connectCurrentRefinements
 * @kind connector
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @propType {function} [clearsQuery=false] - Pass true to also clear the search query
 * @providedPropType {function} refine - a function to remove a single filter
 * @providedPropType {array.<{label: string, attribute: string, currentRefinement: string || object, items: array, value: function}>} items - all the filters, the `value` is to pass to the `refine` function for removing all currentrefinements, `label` is for the display. When existing several refinements for the same atribute name, then you get a nested `items` object that contains a `label` and a `value` function to use to remove a single filter. `attribute` and `currentRefinement` are metadata containing row values.
 * @providedPropType {string} query - the search query
 */

/* harmony default export */ __webpack_exports__["Z"] = ((0,_core_createConnector_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  displayName: 'AlgoliaCurrentRefinements',
  $$type: 'ais.currentRefinements',
  propTypes: {
    transformItems: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func)
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults, metadata) {
    var items = metadata.reduce(function (res, meta) {
      if (typeof meta.items !== 'undefined') {
        if (!props.clearsQuery && meta.id === 'query') {
          return res;
        } else {
          if (props.clearsQuery && meta.id === 'query' && meta.items[0].currentRefinement === '') {
            return res;
          }

          return res.concat(meta.items.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              id: meta.id,
              index: meta.index
            });
          }));
        }
      }

      return res;
    }, []);
    var transformedItems = props.transformItems ? props.transformItems(items) : items;
    return {
      items: transformedItems,
      canRefine: transformedItems.length > 0
    };
  },
  refine: function refine(props, searchState, items) {
    // `value` corresponds to our internal clear function computed in each connector metadata.
    var refinementsToClear = items instanceof Array ? items.map(function (item) {
      return item.value;
    }) : [items];
    return refinementsToClear.reduce(function (res, clear) {
      return clear(res);
    }, searchState);
  }
}));

/***/ }),

/***/ 86694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82269);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69259);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93706);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61970);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_createConnector_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47906);
/* harmony import */ var _core_indexUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40823);
/* harmony import */ var _core_utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95419);



var _excluded = ["page"];





function getId() {
  return 'page';
}

function getCurrentRefinement(props, searchState, context) {
  var id = getId();
  var page = 1;
  var currentRefinement = (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentRefinementValue */ .U6)(props, searchState, context, id, page);

  if (typeof currentRefinement === 'string') {
    return parseInt(currentRefinement, 10);
  }

  return currentRefinement;
}

function getStateWithoutPage(state) {
  var _ref = state || {},
      page = _ref.page,
      rest = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return rest;
}

function getInMemoryCache() {
  var cachedHits = undefined;
  var cachedState = undefined;
  return {
    read: function read(_ref2) {
      var state = _ref2.state;
      return react_fast_compare__WEBPACK_IMPORTED_MODULE_0___default()(cachedState, getStateWithoutPage(state)) ? cachedHits : null;
    },
    write: function write(_ref3) {
      var state = _ref3.state,
          hits = _ref3.hits;
      cachedState = getStateWithoutPage(state);
      cachedHits = hits;
    }
  };
}

function extractHitsFromCachedHits(cachedHits) {
  return Object.keys(cachedHits).map(Number).sort(function (a, b) {
    return a - b;
  }).reduce(function (acc, page) {
    return acc.concat(cachedHits[page]);
  }, []);
}
/**
 * InfiniteHits connector provides the logic to create connected
 * components that will render an continuous list of results retrieved from
 * Algolia. This connector provides a function to load more results.
 * @name connectInfiniteHits
 * @kind connector
 * @providedPropType {array.<object>} hits - the records that matched the search state
 * @providedPropType {boolean} hasMore - indicates if there are more pages to load
 * @providedPropType {function} refine - call to load more results
 */


/* harmony default export */ __webpack_exports__["Z"] = ((0,_core_createConnector_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
  displayName: 'AlgoliaInfiniteHits',
  $$type: 'ais.infiniteHits',
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var _this = this;

    var results = (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .getResults */ .O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (!results) {
      return {
        hits: [],
        hasPrevious: false,
        hasMore: false,
        refine: function refine() {},
        refinePrevious: function refinePrevious() {},
        refineNext: function refineNext() {}
      };
    }

    var page = results.page,
        hits = results.hits,
        hitsPerPage = results.hitsPerPage,
        nbPages = results.nbPages,
        state = results._state;
    this._cache = props.cache ? props.cache : this._cache || getInMemoryCache();
    var cachedHits = this._cache.read({
      state: state
    }) || {};
    var hitsWithPositions = (0,_core_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .addAbsolutePositions */ .RC)(hits, hitsPerPage, page);
    var hitsWithPositionsAndQueryID = (0,_core_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .addQueryID */ .Io)(hitsWithPositions, results.queryID);
    cachedHits[page] = hitsWithPositionsAndQueryID;

    this._cache.write({
      state: state,
      hits: cachedHits
    });
    /*
      Math.min() and Math.max() returns Infinity or -Infinity when no argument is given.
      But there is always something in this point because of `cachedHits[page]`.
    */


    var firstReceivedPage = Math.min.apply(Math, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Object.keys(cachedHits).map(Number)));
    var lastReceivedPage = Math.max.apply(Math, (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Object.keys(cachedHits).map(Number)));
    var hasPrevious = firstReceivedPage > 0;
    var lastPageIndex = nbPages - 1;
    var hasMore = lastReceivedPage < lastPageIndex;

    var refinePrevious = function refinePrevious(event) {
      return _this.refine(event, firstReceivedPage - 1);
    };

    var refineNext = function refineNext(event) {
      return _this.refine(event, lastReceivedPage + 1);
    };

    return {
      hits: extractHitsFromCachedHits(cachedHits),
      hasPrevious: hasPrevious,
      hasMore: hasMore,
      refinePrevious: refinePrevious,
      refineNext: refineNext
    };
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setQueryParameters({
      page: getCurrentRefinement(props, searchState, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }) - 1
    });
  },
  refine: function refine(props, searchState, event, index) {
    var id = getId();

    var nextValue = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, id, index + 1);

    var resetPage = false;
    return (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .refineValue */ .RD)(searchState, nextValue, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, resetPage);
  }
}));

/***/ }),

/***/ 93977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82269);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _core_createConnector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47906);
/* harmony import */ var _core_indexUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40823);
/* harmony import */ var _core_utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95419);





var namespace = 'refinementList';

function getId(props) {
  return props.attribute;
}

function getCurrentRefinement(props, searchState, context) {
  var currentRefinement = (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentRefinementValue */ .U6)(props, searchState, context, "".concat(namespace, ".").concat(getId(props)), []);

  if (typeof currentRefinement !== 'string') {
    return currentRefinement;
  }

  if (currentRefinement) {
    return [currentRefinement];
  }

  return [];
}

function getValue(value, props, searchState, context) {
  var currentRefinement = getCurrentRefinement(props, searchState, context);
  var isAnewValue = currentRefinement.indexOf(value) === -1;
  var nextRefinement = isAnewValue ? currentRefinement.concat([value]) // cannot use .push(), it mutates
  : currentRefinement.filter(function (selectedValue) {
    return selectedValue !== value;
  }); // cannot use .splice(), it mutates

  return nextRefinement;
}

function getLimit(_ref) {
  var showMore = _ref.showMore,
      limit = _ref.limit,
      showMoreLimit = _ref.showMoreLimit;
  return showMore ? showMoreLimit : limit;
}

function _refine(props, searchState, nextRefinement, context) {
  var id = getId(props); // Setting the value to an empty string ensures that it is persisted in
  // the URL as an empty value.
  // This is necessary in the case where `defaultRefinement` contains one
  // item and we try to deselect it. `nextSelected` would be an empty array,
  // which would not be persisted to the URL.
  // {foo: ['bar']} => "foo[0]=bar"
  // {foo: []} => ""

  var nextValue = (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, id, nextRefinement.length > 0 ? nextRefinement : '');

  var resetPage = true;
  return (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .refineValue */ .RD)(searchState, nextValue, context, resetPage, namespace);
}

function _cleanUp(props, searchState, context) {
  return (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .cleanUpValue */ .cI)(searchState, context, "".concat(namespace, ".").concat(getId(props)));
}
/**
 * connectRefinementList connector provides the logic to build a widget that will
 * give the user the ability to choose multiple values for a specific facet.
 * @name connectRefinementList
 * @kind connector
 * @requirements The attribute passed to the `attribute` prop must be present in "attributes for faceting"
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 * @propType {string} attribute - the name of the attribute in the record
 * @propType {boolean} [searchable=false] - allow search inside values
 * @propType {string} [operator=or] - How to apply the refinements. Possible values: 'or' or 'and'.
 * @propType {boolean} [showMore=false] - true if the component should display a button that will expand the number of items
 * @propType {number} [limit=10] - the minimum number of displayed items
 * @propType {number} [showMoreLimit=20] - the maximun number of displayed items. Only used when showMore is set to `true`
 * @propType {string[]} defaultRefinement - the values of the items selected by default. The searchState of this widget takes the form of a list of `string`s, which correspond to the values of all selected refinements. However, when there are no refinements selected, the value of the searchState is an empty string.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string[]} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{count: number, isRefined: boolean, label: string, value: string}>} items - the list of items the RefinementList can display.
 * @providedPropType {function} searchForItems - a function to toggle a search inside items values
 * @providedPropType {boolean} isFromSearch - a boolean that says if the `items` props contains facet values from the global search or from the search inside items.
 * @providedPropType {boolean} canRefine - a boolean that says whether you can refine
 */


var sortBy = ['isRefined', 'count:desc', 'name:asc'];
/* harmony default export */ __webpack_exports__["Z"] = ((0,_core_createConnector_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  displayName: 'AlgoliaRefinementList',
  $$type: 'ais.refinementList',
  propTypes: {
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    attribute: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    operator: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(['and', 'or']),
    showMore: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    limit: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    showMoreLimit: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    defaultRefinement: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)])),
    searchable: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    transformItems: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    facetOrdering: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
  },
  defaultProps: {
    operator: 'or',
    showMore: false,
    limit: 10,
    showMoreLimit: 20,
    facetOrdering: true
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults, metadata, searchForFacetValuesResults) {
    var attribute = props.attribute,
        searchable = props.searchable,
        indexContextValue = props.indexContextValue,
        facetOrdering = props.facetOrdering;
    var results = (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getResults */ .O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var canRefine = Boolean(results) && Boolean(results.getFacetByName(attribute));
    var isFromSearch = Boolean(searchForFacetValuesResults && searchForFacetValuesResults[attribute] && searchForFacetValuesResults.query !== ''); // Search For Facet Values is not available with derived helper (used for multi index search)

    if (searchable && indexContextValue) {
      throw new Error('react-instantsearch: searching in *List is not available when used inside a' + ' multi index context');
    }

    if (!canRefine) {
      return {
        items: [],
        currentRefinement: getCurrentRefinement(props, searchState, {
          ais: props.contextValue,
          multiIndexContext: props.indexContextValue
        }),
        canRefine: canRefine,
        isFromSearch: isFromSearch,
        searchable: searchable
      };
    }

    var items = isFromSearch ? searchForFacetValuesResults[attribute].map(function (v) {
      return {
        label: v.value,
        value: getValue(v.escapedValue, props, searchState, {
          ais: props.contextValue,
          multiIndexContext: props.indexContextValue
        }),
        _highlightResult: {
          label: {
            value: v.highlighted
          }
        },
        count: v.count,
        isRefined: v.isRefined
      };
    }) : results.getFacetValues(attribute, {
      sortBy: sortBy,
      facetOrdering: facetOrdering
    }).map(function (v) {
      return {
        label: v.name,
        value: getValue(v.escapedValue, props, searchState, {
          ais: props.contextValue,
          multiIndexContext: props.indexContextValue
        }),
        count: v.count,
        isRefined: v.isRefined
      };
    });
    var transformedItems = props.transformItems ? props.transformItems(items) : items;
    return {
      items: transformedItems.slice(0, getLimit(props)),
      currentRefinement: getCurrentRefinement(props, searchState, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      isFromSearch: isFromSearch,
      searchable: searchable,
      canRefine: transformedItems.length > 0
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return _refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  searchForFacetValues: function searchForFacetValues(props, searchState, nextRefinement) {
    return {
      facetName: props.attribute,
      query: nextRefinement,
      maxFacetHits: getLimit(props)
    };
  },
  cleanUp: function cleanUp(props, searchState) {
    return _cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var attribute = props.attribute,
        operator = props.operator;
    var addKey = operator === 'and' ? 'addFacet' : 'addDisjunctiveFacet';
    var addRefinementKey = "".concat(addKey, "Refinement");
    searchParameters = searchParameters.setQueryParameters({
      maxValuesPerFacet: Math.max(searchParameters.maxValuesPerFacet || 0, getLimit(props))
    });
    searchParameters = searchParameters[addKey](attribute);
    return getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }).reduce(function (res, val) {
      return res[addRefinementKey](attribute, val);
    }, searchParameters);
  },
  getMetadata: function getMetadata(props, searchState) {
    var id = getId(props);
    var context = {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    };
    return {
      id: id,
      index: (0,_core_indexUtils_js__WEBPACK_IMPORTED_MODULE_0__/* .getIndexId */ .WN)(context),
      items: getCurrentRefinement(props, searchState, context).length > 0 ? [{
        attribute: props.attribute,
        label: "".concat(props.attribute, ": "),
        currentRefinement: getCurrentRefinement(props, searchState, context),
        value: function value(nextState) {
          return _refine(props, nextState, [], context);
        },
        items: getCurrentRefinement(props, searchState, context).map(function (item) {
          return {
            label: (0,_core_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .unescapeFacetValue */ .Zj)("".concat(item)),
            value: function value(nextState) {
              var nextSelectedItems = getCurrentRefinement(props, nextState, context).filter(function (other) {
                return other !== item;
              });
              return _refine(props, searchState, nextSelectedItems, context);
            }
          };
        })
      }] : []
    };
  }
}));

/***/ }),

/***/ 47726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Configure": function() { return /* reexport */ Configure/* default */.Z; },
  "DynamicWidgets": function() { return /* reexport */ widgets_DynamicWidgets; },
  "EXPERIMENTAL_connectConfigureRelatedItems": function() { return /* reexport */ connectConfigureRelatedItems; },
  "EXPERIMENTAL_connectDynamicWidgets": function() { return /* binding */ EXPERIMENTAL_connectDynamicWidgets; },
  "ExperimentalConfigureRelatedItems": function() { return /* reexport */ widgets_ConfigureRelatedItems; },
  "ExperimentalDynamicWidgets": function() { return /* binding */ ExperimentalDynamicWidgets; },
  "HIGHLIGHT_TAGS": function() { return /* reexport */ core_highlight/* HIGHLIGHT_TAGS */.p; },
  "Index": function() { return /* reexport */ widgets_Index; },
  "InstantSearch": function() { return /* reexport */ InstantSearch/* default */.Z; },
  "InstantSearchConsumer": function() { return /* reexport */ context/* InstantSearchConsumer */.BT; },
  "InstantSearchProvider": function() { return /* reexport */ context/* InstantSearchProvider */.tJ; },
  "QueryRuleContext": function() { return /* reexport */ QueryRuleContext; },
  "connectAutoComplete": function() { return /* reexport */ connectAutoComplete; },
  "connectBreadcrumb": function() { return /* reexport */ connectBreadcrumb; },
  "connectConfigure": function() { return /* reexport */ connectConfigure/* default */.Z; },
  "connectCurrentRefinements": function() { return /* reexport */ connectCurrentRefinements/* default */.Z; },
  "connectDynamicWidgets": function() { return /* reexport */ connectDynamicWidgets; },
  "connectGeoSearch": function() { return /* reexport */ connectGeoSearch; },
  "connectHierarchicalMenu": function() { return /* reexport */ connectHierarchicalMenu; },
  "connectHighlight": function() { return /* reexport */ connectHighlight; },
  "connectHitInsights": function() { return /* reexport */ connectHitInsights; },
  "connectHits": function() { return /* reexport */ connectHits/* default */.Z; },
  "connectHitsPerPage": function() { return /* reexport */ connectHitsPerPage; },
  "connectInfiniteHits": function() { return /* reexport */ connectInfiniteHits/* default */.Z; },
  "connectMenu": function() { return /* reexport */ connectMenu; },
  "connectNumericMenu": function() { return /* reexport */ connectNumericMenu; },
  "connectPagination": function() { return /* reexport */ connectPagination; },
  "connectPoweredBy": function() { return /* reexport */ connectPoweredBy; },
  "connectQueryRules": function() { return /* reexport */ connectQueryRules; },
  "connectRange": function() { return /* reexport */ connectRange; },
  "connectRefinementList": function() { return /* reexport */ connectRefinementList/* default */.Z; },
  "connectRelevantSort": function() { return /* reexport */ connectRelevantSort; },
  "connectScrollTo": function() { return /* reexport */ connectScrollTo; },
  "connectSearchBox": function() { return /* reexport */ connectSearchBox/* default */.Z; },
  "connectSortBy": function() { return /* reexport */ connectSortBy; },
  "connectStateResults": function() { return /* reexport */ connectStateResults; },
  "connectStats": function() { return /* reexport */ connectStats; },
  "connectToggleRefinement": function() { return /* reexport */ connectToggleRefinement; },
  "connectVoiceSearch": function() { return /* reexport */ connectVoiceSearch; },
  "createConnector": function() { return /* reexport */ createConnector/* default */.Z; },
  "instantSearchContext": function() { return /* reexport */ context/* instantSearchContext */.aP; },
  "translatable": function() { return /* reexport */ translatable; },
  "version": function() { return /* reexport */ version/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/core/createConnector.js
var createConnector = __webpack_require__(47906);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/core/context.js
var context = __webpack_require__(53634);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/core/highlight.js
var core_highlight = __webpack_require__(75034);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/core/version.js
var version = __webpack_require__(95953);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(62081);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(57642);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(73287);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(44970);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(85471);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(25133);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(64144);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(82269);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/core/translatable.js









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var withKeysPropType = function withKeysPropType(keys) {
  return function (props, propName, componentName) {
    var prop = props[propName];

    if (prop) {
      // eslint-disable-next-line no-restricted-syntax
      for (var _i = 0, _Object$keys = Object.keys(prop); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (keys.indexOf(key) === -1) {
          return new Error("Unknown `".concat(propName, "` key `").concat(key, "`. Check the render method ") + "of `".concat(componentName, "`."));
        }
      }
    }

    return undefined;
  };
};

function translatable(defaultTranslations) {
  return function (Composed) {
    var Translatable = /*#__PURE__*/function (_Component) {
      (0,inherits/* default */.Z)(Translatable, _Component);

      var _super = _createSuper(Translatable);

      function Translatable() {
        var _this;

        (0,classCallCheck/* default */.Z)(this, Translatable);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "translate", function (key) {
          var translations = _this.props.translations;
          var translation = translations && translations.hasOwnProperty(key) ? translations[key] : defaultTranslations[key];

          if (typeof translation === 'function') {
            for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              params[_key2 - 1] = arguments[_key2];
            }

            return translation.apply(void 0, params);
          }

          return translation;
        });

        return _this;
      }

      (0,createClass/* default */.Z)(Translatable, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/react.createElement(Composed, (0,esm_extends/* default */.Z)({
            translate: this.translate
          }, this.props));
        }
      }]);

      return Translatable;
    }(react.Component);

    var name = Composed.displayName || Composed.name || 'UnknownComponent';
    Translatable.displayName = "Translatable(".concat(name, ")");
    Translatable.propTypes = {
      translations: withKeysPropType(Object.keys(defaultTranslations))
    };
    return Translatable;
  };
}
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/Configure.js
var Configure = __webpack_require__(39274);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(69259);
// EXTERNAL MODULE: ./node_modules/.pnpm/algoliasearch-helper@3.11.0_algoliasearch@4.14.2/node_modules/algoliasearch-helper/index.js
var algoliasearch_helper = __webpack_require__(60851);
var algoliasearch_helper_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_helper);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/core/utils.js
var utils = __webpack_require__(95419);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/core/indexUtils.js
var indexUtils = __webpack_require__(40823);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectConfigureRelatedItems.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function createOptionalFilter(_ref) {
  var attributeName = _ref.attributeName,
      attributeValue = _ref.attributeValue,
      attributeScore = _ref.attributeScore;
  return "".concat(attributeName, ":").concat(attributeValue, "<score=").concat(attributeScore || 1, ">");
}

var defaultProps = {
  transformSearchParameters: function transformSearchParameters(x) {
    return _objectSpread({}, x);
  }
};

function getId() {
  // We store the search state of this widget in `configure`.
  return 'configure';
}

function getSearchParametersFromProps(props) {
  var optionalFilters = Object.keys(props.matchingPatterns).reduce(function (acc, attributeName) {
    var attributePattern = props.matchingPatterns[attributeName];
    var attributeValue = (0,utils/* getPropertyByPath */.Es)(props.hit, attributeName);
    var attributeScore = attributePattern.score;

    if (Array.isArray(attributeValue)) {
      return [].concat((0,toConsumableArray/* default */.Z)(acc), [attributeValue.map(function (attributeSubValue) {
        return createOptionalFilter({
          attributeName: attributeName,
          attributeValue: attributeSubValue,
          attributeScore: attributeScore
        });
      })]);
    }

    if (typeof attributeValue === 'string') {
      return [].concat((0,toConsumableArray/* default */.Z)(acc), [createOptionalFilter({
        attributeName: attributeName,
        attributeValue: attributeValue,
        attributeScore: attributeScore
      })]);
    }

    if (false) {}

    return acc;
  }, []);
  return props.transformSearchParameters(new (algoliasearch_helper_default()).SearchParameters({
    // @ts-ignore @TODO algoliasearch-helper@3.0.1 will contain the type
    // `sumOrFiltersScores`.
    // See https://github.com/algolia/algoliasearch-helper-js/pull/753
    sumOrFiltersScores: true,
    facetFilters: ["objectID:-".concat(props.hit.objectID)],
    optionalFilters: optionalFilters
  }));
}

/* harmony default export */ var connectConfigureRelatedItems = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaConfigureRelatedItems',
  $$type: 'ais.configureRelatedItems',
  defaultProps: defaultProps,
  getProvidedProps: function getProvidedProps() {
    return {};
  },
  getSearchParameters: function getSearchParameters(searchParameters, props) {
    return searchParameters.setQueryParameters(getSearchParametersFromProps(props));
  },
  transitionState: function transitionState(props, _prevSearchState, nextSearchState) {
    var id = getId(); // We need to transform the exhaustive search parameters back to clean
    // search parameters without the empty default keys so we don't pollute the
    // `configure` search state.

    var searchParameters = (0,utils/* removeEmptyArraysFromObject */.cC)((0,utils/* removeEmptyKey */.YC)(getSearchParametersFromProps(props)));
    var searchParametersKeys = Object.keys(searchParameters);
    var nonPresentKeys = this._searchParameters ? Object.keys(this._searchParameters).filter(function (prop) {
      return searchParametersKeys.indexOf(prop) === -1;
    }) : [];
    this._searchParameters = searchParameters;

    var nextValue = (0,defineProperty/* default */.Z)({}, id, _objectSpread(_objectSpread({}, (0,utils/* omit */.CE)(nextSearchState[id], nonPresentKeys)), searchParameters));

    return (0,indexUtils/* refineValue */.RD)(nextSearchState, nextValue, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    var _this = this;

    var id = getId();
    var indexId = (0,indexUtils/* getIndexId */.WN)({
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var subState = (0,indexUtils/* hasMultipleIndices */.Ei)({
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }) && searchState.indices ? searchState.indices[indexId] : searchState;
    var configureKeys = subState && subState[id] ? Object.keys(subState[id]) : [];
    var configureState = configureKeys.reduce(function (acc, item) {
      if (!_this._searchParameters[item]) {
        acc[item] = subState[id][item];
      }

      return acc;
    }, {});

    var nextValue = (0,defineProperty/* default */.Z)({}, id, configureState);

    return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  }
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/ConfigureRelatedItems.js



function ConfigureRelatedItems() {
  return null;
}

ConfigureRelatedItems.propTypes = {
  hit: (prop_types_default()).object.isRequired,
  matchingPatterns: (prop_types_default()).object.isRequired,
  transformSearchParameters: (prop_types_default()).func
};
/* harmony default export */ var widgets_ConfigureRelatedItems = (connectConfigureRelatedItems(ConfigureRelatedItems, {
  $$widgetType: 'ais.configureRelatedItems'
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(31307);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectDynamicWidgets.js



var MAX_WILDCARD_FACETS = 20;
/* harmony default export */ var connectDynamicWidgets = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaDynamicWidgets',
  $$type: 'ais.dynamicWidgets',
  defaultProps: {
    transformItems: function transformItems(items) {
      return items;
    },
    maxValuesPerFacet: 20
  },
  propTypes: {
    transformItems: (prop_types_default()).func,
    facets: prop_types_default().arrayOf((prop_types_default()).string),
    maxValuesPerFacet: (prop_types_default()).number
  },
  getProvidedProps: function getProvidedProps(props, _searchState, searchResults) {
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (props.facets && !(Array.isArray(props.facets) && props.facets.length <= 1 && (props.facets[0] === '*' || props.facets[0] === undefined))) {
      throw new Error("The `facets` prop only accepts [] or [\"*\"], you passed ".concat(JSON.stringify(props.facets)));
    }

    if (!results) {
      return {
        attributesToRender: []
      };
    }

    var facetOrder = results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.facets && results.renderingContent.facetOrdering.facets.order || [];
    var attributesToRender = props.transformItems(facetOrder, {
      results: results
    });

    if (attributesToRender.length > MAX_WILDCARD_FACETS && !props.facets) {
      // eslint-disable-next-line no-console
      console.warn("More than ".concat(MAX_WILDCARD_FACETS, " facets are requested to be displayed without explicitly setting which facets to retrieve. This could have a performance impact. Set \"facets\" to [] to do two smaller network requests, or explicitly to ['*'] to avoid this warning."));
    }

    if (props.maxValuesPerFacet < results._state.maxValuesPerFacet) {
      // eslint-disable-next-line no-console
      console.warn("The maxValuesPerFacet set by dynamic widgets (".concat(props.maxValuesPerFacet, ") is smaller than one of the limits set by a widget (").concat(results._state.maxValuesPerFacet, "). This causes a mismatch in query parameters and thus an extra network request when that widget is mounted."));
    }

    return {
      attributesToRender: attributesToRender
    };
  },
  getSearchParameters: function getSearchParameters(searchParameters, props) {
    return (props.facets || ['*']).reduce(function (acc, curr) {
      return acc.addFacet(curr);
    }, searchParameters.setQueryParameters({
      maxValuesPerFacet: Math.max(props.maxValuesPerFacet || 0, searchParameters.maxValuesPerFacet || 0)
    }));
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/DynamicWidgets.js





function isReactElement(element) {
  return (0,esm_typeof/* default */.Z)(element) === 'object' && element.props;
}

function getAttribute(element) {
  if (!isReactElement(element)) {
    return undefined;
  }

  if (element.props.attribute) {
    return element.props.attribute;
  }

  if (Array.isArray(element.props.attributes)) {
    return element.props.attributes[0];
  }

  if (element.props.children) {
    return getAttribute(react.Children.only(element.props.children));
  }

  return undefined;
}

function DynamicWidgets(_ref) {
  var children = _ref.children,
      attributesToRender = _ref.attributesToRender,
      _ref$fallbackComponen = _ref.fallbackComponent,
      Fallback = _ref$fallbackComponen === void 0 ? function () {
    return null;
  } : _ref$fallbackComponen;
  var widgets = new Map();
  react.Children.forEach(children, function (child) {
    var attribute = getAttribute(child);

    if (!attribute) {
      throw new Error("Could not find \"attribute\" prop for ".concat((0,utils/* getDisplayName */.Gf)(child), "."));
    }

    widgets.set(attribute, child);
  }); // on initial render this will be empty, but React InstantSearch keeps
  // search state for unmounted components in place, so routing works.

  return /*#__PURE__*/react.createElement(react.Fragment, null, attributesToRender.map(function (attribute) {
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: attribute
    }, widgets.get(attribute) || /*#__PURE__*/react.createElement(Fallback, {
      attribute: attribute
    }));
  }));
}

/* harmony default export */ var widgets_DynamicWidgets = (connectDynamicWidgets(DynamicWidgets, {
  $$widgetType: 'ais.dynamicWidgets'
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectQueryRules.js




// A context rule must consist only of alphanumeric characters, hyphens, and underscores.
// See https://www.algolia.com/doc/guides/managing-results/refine-results/merchandising-and-promoting/in-depth/implementing-query-rules/#context
function escapeRuleContext(ruleName) {
  return ruleName.replace(/[^a-z0-9-_]+/gi, '_');
}

function getWidgetRefinements(attribute, widgetKey, searchState) {
  var widgetState = searchState[widgetKey];

  switch (widgetKey) {
    case 'range':
      return Object.keys(widgetState[attribute]).map(function (rangeKey) {
        return widgetState[attribute][rangeKey];
      });

    case 'refinementList':
      return widgetState[attribute];

    case 'hierarchicalMenu':
      return [widgetState[attribute]];

    case 'menu':
      return [widgetState[attribute]];

    case 'multiRange':
      return widgetState[attribute].split(':');

    case 'toggle':
      return [widgetState[attribute]];

    default:
      return [];
  }
}

function getRefinements(attribute) {
  var searchState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var refinements = Object.keys(searchState).filter(function (widgetKey) {
    return searchState[widgetKey] !== undefined && searchState[widgetKey][attribute] !== undefined;
  }).map(function (widgetKey) {
    return getWidgetRefinements(attribute, widgetKey, searchState);
  }).reduce(function (acc, current) {
    return acc.concat(current);
  }, []); // flatten the refinements

  return refinements;
}

function getRuleContextsFromTrackedFilters(_ref) {
  var searchState = _ref.searchState,
      trackedFilters = _ref.trackedFilters;
  var ruleContexts = Object.keys(trackedFilters).reduce(function (facets, facetName) {
    var facetRefinements = getRefinements(facetName, searchState);
    var getTrackedFacetValues = trackedFilters[facetName];
    var trackedFacetValues = getTrackedFacetValues(facetRefinements);
    return [].concat((0,toConsumableArray/* default */.Z)(facets), (0,toConsumableArray/* default */.Z)(facetRefinements.filter(function (facetRefinement) {
      return trackedFacetValues.includes(facetRefinement);
    }).map(function (facetValue) {
      return escapeRuleContext("ais-".concat(facetName, "-").concat(facetValue));
    })));
  }, []);
  return ruleContexts;
}

var connectQueryRules_defaultProps = {
  transformItems: function transformItems(items) {
    return items;
  },
  transformRuleContexts: function transformRuleContexts(ruleContexts) {
    return ruleContexts;
  },
  trackedFilters: {}
};
/* harmony default export */ var connectQueryRules = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaQueryRules',
  $$type: 'ais.queryRules',
  defaultProps: connectQueryRules_defaultProps,
  getProvidedProps: function getProvidedProps(props, _1, searchResults) {
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (results === null) {
      return {
        items: [],
        canRefine: false
      };
    }

    var _results$userData = results.userData,
        userData = _results$userData === void 0 ? [] : _results$userData;
    var transformItems = props.transformItems;
    var transformedItems = transformItems(userData);
    return {
      items: transformedItems,
      canRefine: transformedItems.length > 0
    };
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    if (Object.keys(props.trackedFilters).length === 0) {
      return searchParameters;
    }

    var indexSearchState = (0,indexUtils/* hasMultipleIndices */.Ei)({
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }) && searchState.indices ? searchState.indices[(0,indexUtils/* getIndexId */.WN)({
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    })] : searchState;
    var newRuleContexts = getRuleContextsFromTrackedFilters({
      searchState: indexSearchState,
      trackedFilters: props.trackedFilters
    });
    var initialRuleContexts = searchParameters.ruleContexts || [];
    var nextRuleContexts = [].concat((0,toConsumableArray/* default */.Z)(initialRuleContexts), (0,toConsumableArray/* default */.Z)(newRuleContexts));

    if (false) {}

    var ruleContexts = props.transformRuleContexts(nextRuleContexts).slice(0, 10);
    return searchParameters.setQueryParameter('ruleContexts', ruleContexts);
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/QueryRuleContext.js

/* harmony default export */ var QueryRuleContext = (connectQueryRules(function QueryRuleContext() {
  return null;
}, {
  $$widgetType: 'ais.queryRuleContext'
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/Index.js









function Index_createSuper(Derived) { var hasNativeReflectConstruct = Index_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Index_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





function getIndexContext(props) {
  return {
    targetedIndex: props.indexId
  };
}

/**
 * The component that allows you to apply widgets to a dedicated index. It's
 * useful if you want to build an interface that targets multiple indices.
 *
 * @example
 * import React from 'react';
 * import algoliasearch from 'algoliasearch/lite';
 * import { InstantSearch, Index, SearchBox, Hits, Configure } from 'react-instantsearch-dom';
 *
 * const searchClient = algoliasearch(
 *   'latency',
 *   '6be0576ff61c053d5f9a3225e2a90f76'
 * );
 *
 * const App = () => (
 *   <InstantSearch
 *     searchClient={searchClient}
 *     indexName="instant_search"
 *   >
 *     <Configure hitsPerPage={5} />
 *     <SearchBox />
 *     <Index indexName="instant_search">
 *       <Hits />
 *     </Index>
 *     <Index indexName="bestbuy">
 *       <Hits />
 *     </Index>
 *   </InstantSearch>
 * );
 */
var Index = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Index, _Component);

  var _super = Index_createSuper(Index);

  function Index(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Index);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", {
      indexContext: getIndexContext(_this.props)
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "unregisterWidget", void 0);

    _this.props.contextValue.onSearchParameters(_this.getSearchParameters.bind((0,assertThisInitialized/* default */.Z)(_this)), {
      ais: _this.props.contextValue,
      multiIndexContext: _this.state.indexContext
    }, _this.props, undefined, Index.displayName);

    return _this;
  }

  (0,createClass/* default */.Z)(Index, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.unregisterWidget = this.props.contextValue.widgetsManager.registerWidget(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.indexName !== prevProps.indexName) {
        this.props.contextValue.widgetsManager.update();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof this.unregisterWidget === 'function') {
        this.unregisterWidget();
      }
    }
  }, {
    key: "getSearchParameters",
    value: function getSearchParameters(searchParameters, props) {
      return searchParameters.setIndex(this.props ? this.props.indexName : props.indexName);
    }
  }, {
    key: "render",
    value: function render() {
      var childrenCount = react.Children.count(this.props.children);

      if (childrenCount === 0) {
        return null;
      }

      return /*#__PURE__*/react.createElement(context/* IndexProvider */.dW, {
        value: this.state.indexContext
      }, this.props.children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      return {
        indexContext: getIndexContext(props)
      };
    }
  }]);

  return Index;
}(react.Component);

(0,defineProperty/* default */.Z)(Index, "propTypes", {
  indexName: (prop_types_default()).string.isRequired,
  indexId: (prop_types_default()).string.isRequired,
  children: (prop_types_default()).node
});

(0,defineProperty/* default */.Z)(Index, "displayName", 'AlgoliaIndex');

(0,defineProperty/* default */.Z)(Index, "$$type", 'ais.index');

(0,defineProperty/* default */.Z)(Index, "$$widgetType", 'ais.index');

var IndexWrapper = function IndexWrapper(props) {
  var inferredIndexId = props.indexName;
  return /*#__PURE__*/react.createElement(context/* InstantSearchConsumer */.BT, null, function (contextValue) {
    return /*#__PURE__*/react.createElement(Index, (0,esm_extends/* default */.Z)({
      contextValue: contextValue,
      indexId: inferredIndexId
    }, props));
  });
};

IndexWrapper.propTypes = {
  indexName: (prop_types_default()).string.isRequired,
  indexId: (prop_types_default()).string
};
var IndexComponentWithoutContext = (/* unused pure expression or super */ null && (Index));
/* harmony default export */ var widgets_Index = (IndexWrapper);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 4 modules
var InstantSearch = __webpack_require__(13206);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectAutoComplete.js






var connectAutoComplete_getId = function getId() {
  return 'query';
};

function getCurrentRefinement(props, searchState, context) {
  var id = connectAutoComplete_getId();
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, id, '');

  if (currentRefinement) {
    return currentRefinement;
  }

  return '';
}

function getHits(searchResults) {
  if (searchResults.results) {
    if (searchResults.results.hits && Array.isArray(searchResults.results.hits)) {
      return (0,utils/* addAbsolutePositions */.RC)((0,utils/* addQueryID */.Io)(searchResults.results.hits, searchResults.results.queryID), searchResults.results.hitsPerPage, searchResults.results.page);
    } else {
      return Object.keys(searchResults.results).reduce(function (hits, index) {
        return [].concat((0,toConsumableArray/* default */.Z)(hits), [{
          index: index,
          hits: (0,utils/* addAbsolutePositions */.RC)((0,utils/* addQueryID */.Io)(searchResults.results[index].hits, searchResults.results[index].queryID), searchResults.results[index].hitsPerPage, searchResults.results[index].page)
        }]);
      }, []);
    }
  } else {
    return [];
  }
}

function _refine(props, searchState, nextRefinement, context) {
  var id = connectAutoComplete_getId();

  var nextValue = (0,defineProperty/* default */.Z)({}, id, nextRefinement);

  var resetPage = true;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage);
}

function _cleanUp(props, searchState, context) {
  return (0,indexUtils/* cleanUpValue */.cI)(searchState, context, connectAutoComplete_getId());
}
/**
 * connectAutoComplete connector provides the logic to create connected
 * components that will render the results retrieved from
 * Algolia.
 *
 * To configure the number of hits retrieved, use [HitsPerPage widget](widgets/HitsPerPage.html),
 * [connectHitsPerPage connector](connectors/connectHitsPerPage.html) or pass the hitsPerPage
 * prop to a [Configure](guide/Search_parameters.html) widget.
 * @name connectAutoComplete
 * @kind connector
 * @propType {string} [defaultRefinement] - Provide a default value for the query
 * @providedPropType {array.<object>} hits - the records that matched the search state
 * @providedPropType {function} refine - a function to change the query
 * @providedPropType {string} currentRefinement - the query to search for
 */


/* harmony default export */ var connectAutoComplete = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaAutoComplete',
  $$type: 'ais.autoComplete',
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    return {
      hits: getHits(searchResults),
      currentRefinement: getCurrentRefinement(props, searchState, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      })
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return _refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    return _cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },

  /**
   * AutoComplete needs to be considered as a widget to trigger a search,
   * even if no other widgets are used.
   *
   * To be considered as a widget you need either:
   * - getSearchParameters
   * - getMetadata
   * - transitionState
   *
   * See: createConnector.tsx
   */
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setQuery(getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }));
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectBreadcrumb.js




var connectBreadcrumb_getId = function getId(props) {
  return props.attributes[0];
};
var namespace = 'hierarchicalMenu';

function connectBreadcrumb_refine(props, searchState, nextRefinement, context) {
  var id = connectBreadcrumb_getId(props);

  var nextValue = (0,defineProperty/* default */.Z)({}, id, nextRefinement || '');

  var resetPage = true;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage, namespace);
}

function transformValue(values) {
  return values.reduce(function (acc, item) {
    if (item.isRefined) {
      acc.push({
        label: item.name,
        // If dealing with a nested "items", "value" is equal to the previous value concatenated with the current value
        // If dealing with the first level, "value" is equal to the current value
        value: item.escapedValue
      }); // Create a variable in order to keep the same acc for the recursion, otherwise "reduce" returns a new one

      if (item.data) {
        acc = acc.concat(transformValue(item.data, acc));
      }
    }

    return acc;
  }, []);
}
/**
 * The breadcrumb component is s a type of secondary navigation scheme that
 * reveals the user’s location in a website or web application.
 *
 * @name connectBreadcrumb
 * @requirements To use this widget, your attributes must be formatted in a specific way.
 * If you want for example to have a Breadcrumb of categories, objects in your index
 * should be formatted this way:
 *
 * ```json
 * {
 *   "categories.lvl0": "products",
 *   "categories.lvl1": "products > fruits",
 *   "categories.lvl2": "products > fruits > citrus"
 * }
 * ```
 *
 * It's also possible to provide more than one path for each level:
 *
 * ```json
 * {
 *   "categories.lvl0": ["products", "goods"],
 *   "categories.lvl1": ["products > fruits", "goods > to eat"]
 * }
 * ```
 *
 * All attributes passed to the `attributes` prop must be present in "attributes for faceting"
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 *
 * @kind connector
 * @propType {array.<string>} attributes - List of attributes to use to generate the hierarchy of the menu. See the example for the convention to follow.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {array.<{items: object, count: number, isRefined: boolean, label: string, value: string}>} items - the list of items the Breadcrumb can display.
 */


/* harmony default export */ var connectBreadcrumb = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaBreadcrumb',
  $$type: 'ais.breadcrumb',
  propTypes: {
    attributes: function attributes(props, propName, componentName) {
      var isNotString = function isNotString(val) {
        return typeof val !== 'string';
      };

      if (!Array.isArray(props[propName]) || props[propName].some(isNotString) || props[propName].length < 1) {
        return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Expected an Array of Strings"));
      }

      return undefined;
    },
    transformItems: (prop_types_default()).func
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var id = connectBreadcrumb_getId(props);
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var isFacetPresent = Boolean(results) && Boolean(results.getFacetByName(id));

    if (!isFacetPresent) {
      return {
        items: [],
        canRefine: false
      };
    }

    var values = results.getFacetValues(id);
    var items = values.data ? transformValue(values.data) : [];
    var transformedItems = props.transformItems ? props.transformItems(items) : items;
    return {
      canRefine: transformedItems.length > 0,
      items: transformedItems
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return connectBreadcrumb_refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  }
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectConfigure.js
var connectConfigure = __webpack_require__(49046);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectCurrentRefinements.js
var connectCurrentRefinements = __webpack_require__(13502);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(93706);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectGeoSearch.js


var _excluded = ["defaultRefinement"];



/**
 * The GeoSearch connector provides the logic to build a widget that will display the results on a map.
 * It also provides a way to search for results based on their position. The connector provides function to manage the search experience (search on map interaction).
 * @name connectGeoSearch
 * @kind connector
 * @requirements Note that the GeoSearch connector uses the [geosearch](https://www.algolia.com/doc/guides/searching/geo-search) capabilities of Algolia.
 * Your hits **must** have a `_geoloc` attribute in order to be passed to the rendering function. Currently, the feature is not compatible with multiple values in the `_geoloc` attribute
 * (e.g. a restaurant with multiple locations). In that case you can duplicate your records and use the [distinct](https://www.algolia.com/doc/guides/ranking/distinct) feature of Algolia to only retrieve unique results.
 * @propType {{ northEast: { lat: number, lng: number }, southWest: { lat: number, lng: number } }} [defaultRefinement] - Default search state of the widget containing the bounds for the map
 * @providedPropType {function({ northEast: { lat: number, lng: number }, southWest: { lat: number, lng: number } })} refine - a function to toggle the refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {array.<object>} hits - the records that matched the search
 * @providedPropType {boolean} isRefinedWithMap - true if the current refinement is set with the map bounds
 * @providedPropType {{ northEast: { lat: number, lng: number }, southWest: { lat: number, lng: number } }} [currentRefinement] - the refinement currently applied
 * @providedPropType {{ lat: number, lng: number }} [position] - the position of the search
 */
// To control the map with an external widget the other widget
// **must** write the value in the attribute `aroundLatLng`

var getBoundingBoxId = function getBoundingBoxId() {
  return 'boundingBox';
};

var getAroundLatLngId = function getAroundLatLngId() {
  return 'aroundLatLng';
};

var getConfigureAroundLatLngId = function getConfigureAroundLatLngId() {
  return 'configure.aroundLatLng';
};

var currentRefinementToString = function currentRefinementToString(currentRefinement) {
  return [currentRefinement.northEast.lat, currentRefinement.northEast.lng, currentRefinement.southWest.lat, currentRefinement.southWest.lng].join();
};

var stringToCurrentRefinement = function stringToCurrentRefinement(value) {
  var values = value.split(',');
  return {
    northEast: {
      lat: parseFloat(values[0]),
      lng: parseFloat(values[1])
    },
    southWest: {
      lat: parseFloat(values[2]),
      lng: parseFloat(values[3])
    }
  };
};

var latLngRegExp = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/;

var stringToPosition = function stringToPosition(value) {
  var pattern = value.match(latLngRegExp);
  return {
    lat: parseFloat(pattern[1]),
    lng: parseFloat(pattern[2])
  };
};

var connectGeoSearch_getCurrentRefinement = function getCurrentRefinement(props, searchState, context) {
  var refinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, getBoundingBoxId(), {});

  if (!(0,utils/* objectHasKeys */.a4)(refinement)) {
    return;
  } // eslint-disable-next-line consistent-return


  return {
    northEast: {
      lat: parseFloat(refinement.northEast.lat),
      lng: parseFloat(refinement.northEast.lng)
    },
    southWest: {
      lat: parseFloat(refinement.southWest.lat),
      lng: parseFloat(refinement.southWest.lng)
    }
  };
};

var getCurrentPosition = function getCurrentPosition(props, searchState, context) {
  var defaultRefinement = props.defaultRefinement,
      propsWithoutDefaultRefinement = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var aroundLatLng = (0,indexUtils/* getCurrentRefinementValue */.U6)(propsWithoutDefaultRefinement, searchState, context, getAroundLatLngId());

  if (!aroundLatLng) {
    // Fallback on `configure.aroundLatLng`
    var configureAroundLatLng = (0,indexUtils/* getCurrentRefinementValue */.U6)(propsWithoutDefaultRefinement, searchState, context, getConfigureAroundLatLngId());
    return configureAroundLatLng && stringToPosition(configureAroundLatLng);
  }

  return aroundLatLng;
};

var connectGeoSearch_refine = function refine(searchState, nextValue, context) {
  var resetPage = true;

  var nextRefinement = (0,defineProperty/* default */.Z)({}, getBoundingBoxId(), nextValue);

  return (0,indexUtils/* refineValue */.RD)(searchState, nextRefinement, context, resetPage);
};

/* harmony default export */ var connectGeoSearch = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaGeoSearch',
  $$type: 'ais.geoSearch',
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var context = {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    };
    var results = (0,indexUtils/* getResults */.O7)(searchResults, context); // We read it from both because the SearchParameters & the searchState are not always
    // in sync. When we set the refinement the searchState is used but when we clear the refinement
    // the SearchParameters is used. In the first case when we render, the results are not there
    // so we can't find the value from the results. The most up to date value is the searchState.
    // But when we clear the refinement the searchState is immediately cleared even when the items
    // retrieved are still the one from the previous query with the bounding box. It leads to some
    // issue with the position of the map. We should rely on 1 source of truth or at least always
    // be sync.

    var currentRefinementFromSearchState = connectGeoSearch_getCurrentRefinement(props, searchState, context);
    var currentRefinementFromSearchParameters = results && results._state.insideBoundingBox && stringToCurrentRefinement(results._state.insideBoundingBox) || undefined;
    var currentPositionFromSearchState = getCurrentPosition(props, searchState, context);
    var currentPositionFromSearchParameters = results && results._state.aroundLatLng && stringToPosition(results._state.aroundLatLng) || undefined;
    var currentRefinement = currentRefinementFromSearchState || currentRefinementFromSearchParameters;
    var position = currentPositionFromSearchState || currentPositionFromSearchParameters;
    return {
      hits: !results ? [] : results.hits.filter(function (_) {
        return Boolean(_._geoloc);
      }),
      isRefinedWithMap: Boolean(currentRefinement),
      currentRefinement: currentRefinement,
      position: position
    };
  },
  refine: function refine(props, searchState, nextValue) {
    return connectGeoSearch_refine(searchState, nextValue, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var currentRefinement = connectGeoSearch_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (!currentRefinement) {
      return searchParameters;
    }

    return searchParameters.setQueryParameter('insideBoundingBox', currentRefinementToString(currentRefinement));
  },
  cleanUp: function cleanUp(props, searchState) {
    return (0,indexUtils/* cleanUpValue */.cI)(searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, getBoundingBoxId());
  },
  getMetadata: function getMetadata(props, searchState) {
    var items = [];
    var id = getBoundingBoxId();
    var context = {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    };
    var index = (0,indexUtils/* getIndexId */.WN)(context);
    var nextRefinement = {};
    var currentRefinement = connectGeoSearch_getCurrentRefinement(props, searchState, context);

    if (currentRefinement) {
      items.push({
        label: "".concat(id, ": ").concat(currentRefinementToString(currentRefinement)),
        value: function value(nextState) {
          return connectGeoSearch_refine(nextState, nextRefinement, context);
        },
        currentRefinement: currentRefinement
      });
    }

    return {
      id: id,
      index: index,
      items: items
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate() {
    return true;
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectHierarchicalMenu.js


function connectHierarchicalMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function connectHierarchicalMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? connectHierarchicalMenu_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : connectHierarchicalMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var connectHierarchicalMenu_getId = function getId(props) {
  return props.attributes[0];
};
var connectHierarchicalMenu_namespace = 'hierarchicalMenu';

function connectHierarchicalMenu_getCurrentRefinement(props, searchState, context) {
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, "".concat(connectHierarchicalMenu_namespace, ".").concat(connectHierarchicalMenu_getId(props)), null);

  if (currentRefinement === '') {
    return null;
  }

  return currentRefinement;
}

function getValue(value, props, searchState, context) {
  var id = props.id,
      attributes = props.attributes,
      separator = props.separator,
      rootPath = props.rootPath,
      showParentLevel = props.showParentLevel;
  var currentRefinement = connectHierarchicalMenu_getCurrentRefinement(props, searchState, context);
  var nextRefinement;

  if (currentRefinement === null) {
    nextRefinement = value;
  } else {
    var tmpSearchParameters = new (algoliasearch_helper_default()).SearchParameters({
      hierarchicalFacets: [{
        name: id,
        attributes: attributes,
        separator: separator,
        rootPath: rootPath,
        showParentLevel: showParentLevel
      }]
    });
    nextRefinement = tmpSearchParameters.toggleHierarchicalFacetRefinement(id, currentRefinement).toggleHierarchicalFacetRefinement(id, value).getHierarchicalRefinement(id)[0];
  }

  return nextRefinement;
}

function connectHierarchicalMenu_transformValue(value, props, searchState, context) {
  return value.map(function (v) {
    return {
      label: v.name,
      value: getValue(v.escapedValue, props, searchState, context),
      count: v.count,
      isRefined: v.isRefined,
      items: v.data && connectHierarchicalMenu_transformValue(v.data, props, searchState, context)
    };
  });
}

var truncate = function truncate() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return items.slice(0, limit).map(function () {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Array.isArray(item.items) ? connectHierarchicalMenu_objectSpread(connectHierarchicalMenu_objectSpread({}, item), {}, {
      items: truncate(item.items, limit)
    }) : item;
  });
};

function connectHierarchicalMenu_refine(props, searchState, nextRefinement, context) {
  var id = connectHierarchicalMenu_getId(props);

  var nextValue = (0,defineProperty/* default */.Z)({}, id, nextRefinement || '');

  var resetPage = true;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage, connectHierarchicalMenu_namespace);
}

function connectHierarchicalMenu_cleanUp(props, searchState, context) {
  return (0,indexUtils/* cleanUpValue */.cI)(searchState, context, "".concat(connectHierarchicalMenu_namespace, ".").concat(connectHierarchicalMenu_getId(props)));
}

var sortBy = ['name:asc'];
/**
 * connectHierarchicalMenu connector provides the logic to build a widget that will
 * give the user the ability to explore a tree-like structure.
 * This is commonly used for multi-level categorization of products on e-commerce
 * websites. From a UX point of view, we suggest not displaying more than two levels deep.
 * @name connectHierarchicalMenu
 * @requirements To use this widget, your attributes must be formatted in a specific way.
 * If you want for example to have a hierarchical menu of categories, objects in your index
 * should be formatted this way:
 *
 * ```json
 * {
 *   "categories.lvl0": "products",
 *   "categories.lvl1": "products > fruits",
 *   "categories.lvl2": "products > fruits > citrus"
 * }
 * ```
 *
 * It's also possible to provide more than one path for each level:
 *
 * ```json
 * {
 *   "categories.lvl0": ["products", "goods"],
 *   "categories.lvl1": ["products > fruits", "goods > to eat"]
 * }
 * ```
 *
 * All attributes passed to the `attributes` prop must be present in "attributes for faceting"
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 *
 * @kind connector
 * @propType {array.<string>} attributes - List of attributes to use to generate the hierarchy of the menu. See the example for the convention to follow.
 * @propType {string} [defaultRefinement] - the item value selected by default
 * @propType {boolean} [showMore=false] - Flag to activate the show more button, for toggling the number of items between limit and showMoreLimit.
 * @propType {number} [limit=10] -  The maximum number of items displayed.
 * @propType {number} [showMoreLimit=20] -  The maximum number of items displayed when the user triggers the show more. Not considered if `showMore` is false.
 * @propType {string} [separator='>'] -  Specifies the level separator used in the data.
 * @propType {string} [rootPath=null] - The path to use if the first level is not the root level.
 * @propType {boolean} [showParentLevel=true] - Flag to set if the parent level should be displayed.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{items: object, count: number, isRefined: boolean, label: string, value: string}>} items - the list of items the HierarchicalMenu can display. items has the same shape as parent items.
 */

/* harmony default export */ var connectHierarchicalMenu = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaHierarchicalMenu',
  $$type: 'ais.hierarchicalMenu',
  propTypes: {
    attributes: function attributes(props, propName, componentName) {
      var isNotString = function isNotString(val) {
        return typeof val !== 'string';
      };

      if (!Array.isArray(props[propName]) || props[propName].some(isNotString) || props[propName].length < 1) {
        return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Expected an Array of Strings"));
      }

      return undefined;
    },
    separator: (prop_types_default()).string,
    rootPath: (prop_types_default()).string,
    showParentLevel: (prop_types_default()).bool,
    defaultRefinement: (prop_types_default()).string,
    showMore: (prop_types_default()).bool,
    limit: (prop_types_default()).number,
    showMoreLimit: (prop_types_default()).number,
    transformItems: (prop_types_default()).func,
    facetOrdering: (prop_types_default()).bool
  },
  defaultProps: {
    showMore: false,
    limit: 10,
    showMoreLimit: 20,
    separator: ' > ',
    rootPath: null,
    showParentLevel: true,
    facetOrdering: true
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var showMore = props.showMore,
        limit = props.limit,
        showMoreLimit = props.showMoreLimit,
        facetOrdering = props.facetOrdering;
    var id = connectHierarchicalMenu_getId(props);
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var isFacetPresent = Boolean(results) && Boolean(results.getFacetByName(id));

    if (!isFacetPresent) {
      return {
        items: [],
        currentRefinement: connectHierarchicalMenu_getCurrentRefinement(props, searchState, {
          ais: props.contextValue,
          multiIndexContext: props.indexContextValue
        }),
        canRefine: false
      };
    }

    var itemsLimit = showMore ? showMoreLimit : limit;
    var value = results.getFacetValues(id, {
      sortBy: sortBy,
      facetOrdering: facetOrdering
    });
    var items = value.data ? connectHierarchicalMenu_transformValue(value.data, props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }) : [];
    var transformedItems = props.transformItems ? props.transformItems(items) : items;
    return {
      items: truncate(transformedItems, itemsLimit),
      currentRefinement: connectHierarchicalMenu_getCurrentRefinement(props, searchState, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      canRefine: transformedItems.length > 0
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return connectHierarchicalMenu_refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    return connectHierarchicalMenu_cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var attributes = props.attributes,
        separator = props.separator,
        rootPath = props.rootPath,
        showParentLevel = props.showParentLevel,
        showMore = props.showMore,
        limit = props.limit,
        showMoreLimit = props.showMoreLimit,
        contextValue = props.contextValue;
    var id = connectHierarchicalMenu_getId(props);
    var itemsLimit = showMore ? showMoreLimit : limit;
    searchParameters = searchParameters.addHierarchicalFacet({
      name: id,
      attributes: attributes,
      separator: separator,
      rootPath: rootPath,
      showParentLevel: showParentLevel
    }).setQueryParameters({
      maxValuesPerFacet: Math.max(searchParameters.maxValuesPerFacet || 0, itemsLimit)
    });
    var currentRefinement = connectHierarchicalMenu_getCurrentRefinement(props, searchState, {
      ais: contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (currentRefinement !== null) {
      searchParameters = searchParameters.toggleHierarchicalFacetRefinement(id, currentRefinement);
    }

    return searchParameters;
  },
  getMetadata: function getMetadata(props, searchState) {
    var rootAttribute = props.attributes[0];
    var id = connectHierarchicalMenu_getId(props);
    var currentRefinement = connectHierarchicalMenu_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var items = !currentRefinement ? [] : [{
      label: "".concat(rootAttribute, ": ").concat((0,utils/* unescapeFacetValue */.Zj)(currentRefinement)),
      attribute: rootAttribute,
      value: function value(nextState) {
        return connectHierarchicalMenu_refine(props, nextState, '', {
          ais: props.contextValue,
          multiIndexContext: props.indexContextValue
        });
      },
      currentRefinement: currentRefinement
    }];
    return {
      id: id,
      index: (0,indexUtils/* getIndexId */.WN)({
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      items: items
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectHighlight.js



var highlight = function highlight(_ref) {
  var attribute = _ref.attribute,
      hit = _ref.hit,
      highlightProperty = _ref.highlightProperty,
      _ref$preTag = _ref.preTag,
      preTag = _ref$preTag === void 0 ? core_highlight/* HIGHLIGHT_TAGS.highlightPreTag */.p.highlightPreTag : _ref$preTag,
      _ref$postTag = _ref.postTag,
      postTag = _ref$postTag === void 0 ? core_highlight/* HIGHLIGHT_TAGS.highlightPostTag */.p.highlightPostTag : _ref$postTag;
  return (0,core_highlight/* parseAlgoliaHit */.$)({
    attribute: attribute,
    highlightProperty: highlightProperty,
    hit: hit,
    preTag: preTag,
    postTag: postTag
  });
};
/**
 * connectHighlight connector provides the logic to create an highlighter
 * component that will retrieve, parse and render an highlighted attribute
 * from an Algolia hit.
 * @name connectHighlight
 * @kind connector
 * @category connector
 * @providedPropType {function} highlight - function to retrieve and parse an attribute from a hit. It takes a configuration object with 3 attributes: `highlightProperty` which is the property that contains the highlight structure from the records, `attribute` which is the name of the attribute (it can be either a string or an array of strings) to look for and `hit` which is the hit from Algolia. It returns an array of objects `{value: string, isHighlighted: boolean}`. If the element that corresponds to the attribute is an array of strings, it will return a nested array of objects.
 * @example
 * import React from 'react';
 * import algoliasearch from 'algoliasearch/lite';
 * import { InstantSearch, SearchBox, Hits, connectHighlight } from 'react-instantsearch-dom';
 *
 * const searchClient = algoliasearch(
 *   'latency',
 *   '6be0576ff61c053d5f9a3225e2a90f76'
 * );
 *
 * const CustomHighlight = connectHighlight(
 *   ({ highlight, attribute, hit, highlightProperty }) => {
 *     const highlights = highlight({
 *       highlightProperty: '_highlightResult',
 *       attribute,
 *       hit
 *     });
 *
 *     return highlights.map(part => part.isHighlighted ? (
 *       <mark>{part.value}</mark>
 *     ) : (
 *       <span>{part.value}</span>
 *     ));
 *   }
 * );
 *
 * const Hit = ({ hit }) => (
 *   <p>
 *     <CustomHighlight attribute="name" hit={hit} />
 *   </p>
 * );
 *
 * const App = () => (
 *   <InstantSearch
 *     searchClient={searchClient}
 *     indexName="instant_search"
 *   >
 *     <SearchBox defaultRefinement="pho" />
 *     <Hits hitComponent={Hit} />
 *   </InstantSearch>
 * );
 */


/* harmony default export */ var connectHighlight = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaHighlighter',
  $$type: 'ais.highlighter',
  propTypes: {},
  getProvidedProps: function getProvidedProps() {
    return {
      highlight: highlight
    };
  }
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectHits.js
var connectHits = __webpack_require__(6988);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectHitsPerPage.js


function connectHitsPerPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function connectHitsPerPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? connectHitsPerPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : connectHitsPerPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function connectHitsPerPage_getId() {
  return 'hitsPerPage';
}

function connectHitsPerPage_getCurrentRefinement(props, searchState, context) {
  var id = connectHitsPerPage_getId();
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, id, null);

  if (typeof currentRefinement === 'string') {
    return parseInt(currentRefinement, 10);
  }

  return currentRefinement;
}
/**
 * connectHitsPerPage connector provides the logic to create connected
 * components that will allow a user to choose to display more or less results from Algolia.
 * @name connectHitsPerPage
 * @kind connector
 * @propType {number} defaultRefinement - The number of items selected by default
 * @propType {{value: number, label: string}[]} items - List of hits per page options.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to remove a single filter
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{isRefined: boolean, label?: string, value: number}>} items - the list of items the HitsPerPage can display. If no label provided, the value will be displayed.
 */


/* harmony default export */ var connectHitsPerPage = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaHitsPerPage',
  $$type: 'ais.hitsPerPage',
  propTypes: {
    defaultRefinement: (prop_types_default()).number.isRequired,
    items: prop_types_default().arrayOf(prop_types_default().shape({
      label: (prop_types_default()).string,
      value: (prop_types_default()).number.isRequired
    })).isRequired,
    transformItems: (prop_types_default()).func
  },
  getProvidedProps: function getProvidedProps(props, searchState) {
    var currentRefinement = connectHitsPerPage_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var items = props.items.map(function (item) {
      return item.value === currentRefinement ? connectHitsPerPage_objectSpread(connectHitsPerPage_objectSpread({}, item), {}, {
        isRefined: true
      }) : connectHitsPerPage_objectSpread(connectHitsPerPage_objectSpread({}, item), {}, {
        isRefined: false
      });
    });
    return {
      items: props.transformItems ? props.transformItems(items) : items,
      currentRefinement: currentRefinement
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    var id = connectHitsPerPage_getId();

    var nextValue = (0,defineProperty/* default */.Z)({}, id, nextRefinement);

    var resetPage = true;
    return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, resetPage);
  },
  cleanUp: function cleanUp(props, searchState) {
    return (0,indexUtils/* cleanUpValue */.cI)(searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, connectHitsPerPage_getId());
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setHitsPerPage(connectHitsPerPage_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }));
  },
  getMetadata: function getMetadata() {
    return {
      id: connectHitsPerPage_getId()
    };
  }
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectInfiniteHits.js
var connectInfiniteHits = __webpack_require__(86694);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectMenu.js





var connectMenu_namespace = 'menu';

function connectMenu_getId(props) {
  return props.attribute;
}

function connectMenu_getCurrentRefinement(props, searchState, context) {
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, "".concat(connectMenu_namespace, ".").concat(connectMenu_getId(props)), null);

  if (currentRefinement === '') {
    return null;
  }

  return currentRefinement;
}

function connectMenu_getValue(value, props, searchState, context) {
  var currentRefinement = connectMenu_getCurrentRefinement(props, searchState, context);
  return value === currentRefinement ? '' : value;
}

function getLimit(_ref) {
  var showMore = _ref.showMore,
      limit = _ref.limit,
      showMoreLimit = _ref.showMoreLimit;
  return showMore ? showMoreLimit : limit;
}

function connectMenu_refine(props, searchState, nextRefinement, context) {
  var id = connectMenu_getId(props);

  var nextValue = (0,defineProperty/* default */.Z)({}, id, nextRefinement ? nextRefinement : '');

  var resetPage = true;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage, connectMenu_namespace);
}

function connectMenu_cleanUp(props, searchState, context) {
  return (0,indexUtils/* cleanUpValue */.cI)(searchState, context, "".concat(connectMenu_namespace, ".").concat(connectMenu_getId(props)));
}

var defaultSortBy = ['count:desc', 'name:asc'];
/**
 * connectMenu connector provides the logic to build a widget that will
 * give the user the ability to choose a single value for a specific facet.
 * @name connectMenu
 * @requirements The attribute passed to the `attribute` prop must be present in "attributes for faceting"
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 * @kind connector
 * @propType {string} attribute - the name of the attribute in the record
 * @propType {boolean} [showMore=false] - true if the component should display a button that will expand the number of items
 * @propType {number} [limit=10] - the minimum number of diplayed items
 * @propType {number} [showMoreLimit=20] - the maximun number of displayed items. Only used when showMore is set to `true`
 * @propType {string} [defaultRefinement] - the value of the item selected by default
 * @propType {boolean} [searchable=false] - allow search inside values
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{count: number, isRefined: boolean, label: string, value: string}>} items - the list of items the Menu can display.
 * @providedPropType {function} searchForItems - a function to toggle a search inside items values
 * @providedPropType {boolean} isFromSearch - a boolean that says if the `items` props contains facet values from the global search or from the search inside items.
 */

/* harmony default export */ var connectMenu = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaMenu',
  $$type: 'ais.menu',
  propTypes: {
    attribute: (prop_types_default()).string.isRequired,
    showMore: (prop_types_default()).bool,
    limit: (prop_types_default()).number,
    showMoreLimit: (prop_types_default()).number,
    defaultRefinement: (prop_types_default()).string,
    transformItems: (prop_types_default()).func,
    searchable: (prop_types_default()).bool,
    facetOrdering: (prop_types_default()).bool
  },
  defaultProps: {
    showMore: false,
    limit: 10,
    showMoreLimit: 20,
    facetOrdering: true
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults, meta, searchForFacetValuesResults) {
    var attribute = props.attribute,
        searchable = props.searchable,
        indexContextValue = props.indexContextValue,
        facetOrdering = props.facetOrdering;
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var canRefine = Boolean(results) && Boolean(results.getFacetByName(attribute));
    var isFromSearch = Boolean(searchForFacetValuesResults && searchForFacetValuesResults[attribute] && searchForFacetValuesResults.query !== ''); // Search For Facet Values is not available with derived helper (used for multi index search)

    if (searchable && indexContextValue) {
      throw new Error('react-instantsearch: searching in *List is not available when used inside a' + ' multi index context');
    }

    if (!canRefine) {
      return {
        items: [],
        currentRefinement: connectMenu_getCurrentRefinement(props, searchState, {
          ais: props.contextValue,
          multiIndexContext: props.indexContextValue
        }),
        isFromSearch: isFromSearch,
        searchable: searchable,
        canRefine: canRefine
      };
    }

    var items;

    if (isFromSearch) {
      items = searchForFacetValuesResults[attribute].map(function (v) {
        return {
          label: v.value,
          value: connectMenu_getValue(v.escapedValue, props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
          }),
          _highlightResult: {
            label: {
              value: v.highlighted
            }
          },
          count: v.count,
          isRefined: v.isRefined
        };
      });
    } else {
      items = results.getFacetValues(attribute, {
        sortBy: searchable ? undefined : defaultSortBy,
        facetOrdering: facetOrdering
      }).map(function (v) {
        return {
          label: v.name,
          value: connectMenu_getValue(v.escapedValue, props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
          }),
          count: v.count,
          isRefined: v.isRefined
        };
      });
    }

    var transformedItems = props.transformItems ? props.transformItems(items) : items;
    return {
      items: transformedItems.slice(0, getLimit(props)),
      currentRefinement: connectMenu_getCurrentRefinement(props, searchState, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      isFromSearch: isFromSearch,
      searchable: searchable,
      canRefine: transformedItems.length > 0
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return connectMenu_refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  searchForFacetValues: function searchForFacetValues(props, searchState, nextRefinement) {
    return {
      facetName: props.attribute,
      query: nextRefinement,
      maxFacetHits: getLimit(props)
    };
  },
  cleanUp: function cleanUp(props, searchState) {
    return connectMenu_cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var attribute = props.attribute;
    searchParameters = searchParameters.setQueryParameters({
      maxValuesPerFacet: Math.max(searchParameters.maxValuesPerFacet || 0, getLimit(props))
    });
    searchParameters = searchParameters.addDisjunctiveFacet(attribute);
    var currentRefinement = connectMenu_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (currentRefinement !== null) {
      searchParameters = searchParameters.addDisjunctiveFacetRefinement(attribute, currentRefinement);
    }

    return searchParameters;
  },
  getMetadata: function getMetadata(props, searchState) {
    var id = connectMenu_getId(props);
    var currentRefinement = connectMenu_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    return {
      id: id,
      index: (0,indexUtils/* getIndexId */.WN)({
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      items: currentRefinement === null ? [] : [{
        label: "".concat(props.attribute, ": ").concat((0,utils/* unescapeFacetValue */.Zj)(currentRefinement)),
        attribute: props.attribute,
        value: function value(nextState) {
          return connectMenu_refine(props, nextState, '', {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
          });
        },
        currentRefinement: currentRefinement
      }]
    };
  }
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(52542);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectNumericMenu.js







function stringifyItem(item) {
  if (typeof item.start === 'undefined' && typeof item.end === 'undefined') {
    return '';
  }

  var start = typeof item.start !== 'undefined' ? item.start : '';
  var end = typeof item.end !== 'undefined' ? item.end : '';
  return "".concat(start, ":").concat(end);
}

function parseItem(value) {
  if (value.length === 0) {
    return {
      start: null,
      end: null
    };
  }

  var _value$split = value.split(':'),
      _value$split2 = (0,slicedToArray/* default */.Z)(_value$split, 2),
      startStr = _value$split2[0],
      endStr = _value$split2[1];

  return {
    start: startStr.length > 0 ? parseFloat(startStr) : null,
    end: endStr.length > 0 ? parseFloat(endStr) : null
  };
}

var connectNumericMenu_namespace = 'multiRange';

function connectNumericMenu_getId(props) {
  return props.attribute;
}

function connectNumericMenu_getCurrentRefinement(props, searchState, context) {
  return (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, "".concat(connectNumericMenu_namespace, ".").concat(connectNumericMenu_getId(props)), '', function (currentRefinement) {
    if (currentRefinement === '') {
      return '';
    }

    return currentRefinement;
  });
}

function isRefinementsRangeIncludesInsideItemRange(stats, start, end) {
  return stats.min >= start && stats.min <= end || stats.max >= start && stats.max <= end;
}

function isItemRangeIncludedInsideRefinementsRange(stats, start, end) {
  return start >= stats.min && start <= stats.max || end >= stats.min && end <= stats.max;
}

function itemHasRefinement(attribute, results, value) {
  var stats = results.getFacetByName(attribute) ? results.getFacetStats(attribute) : null;
  var range = value.split(':');
  var start = Number(range[0]) === 0 || value === '' ? Number.NEGATIVE_INFINITY : Number(range[0]);
  var end = Number(range[1]) === 0 || value === '' ? Number.POSITIVE_INFINITY : Number(range[1]);
  return !(Boolean(stats) && (isRefinementsRangeIncludesInsideItemRange(stats, start, end) || isItemRangeIncludedInsideRefinementsRange(stats, start, end)));
}

function connectNumericMenu_refine(props, searchState, nextRefinement, context) {
  var nextValue = (0,defineProperty/* default */.Z)({}, connectNumericMenu_getId(props, searchState), nextRefinement);

  var resetPage = true;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage, connectNumericMenu_namespace);
}

function connectNumericMenu_cleanUp(props, searchState, context) {
  return (0,indexUtils/* cleanUpValue */.cI)(searchState, context, "".concat(connectNumericMenu_namespace, ".").concat(connectNumericMenu_getId(props)));
}
/**
 * connectNumericMenu connector provides the logic to build a widget that will
 * give the user the ability to select a range value for a numeric attribute.
 * Ranges are defined statically.
 * @name connectNumericMenu
 * @requirements The attribute passed to the `attribute` prop must be holding numerical values.
 * @kind connector
 * @propType {string} attribute - the name of the attribute in the records
 * @propType {{label: string, start: number, end: number}[]} items - List of options. With a text label, and upper and lower bounds.
 * @propType {string} [defaultRefinement] - the value of the item selected by default, follow the shape of a `string` with a pattern of `'{start}:{end}'`.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to select a range.
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the refinement currently applied.  follow the shape of a `string` with a pattern of `'{start}:{end}'` which corresponds to the current selected item. For instance, when the selected item is `{start: 10, end: 20}`, the searchState of the widget is `'10:20'`. When `start` isn't defined, the searchState of the widget is `':{end}'`, and the same way around when `end` isn't defined. However, when neither `start` nor `end` are defined, the searchState is an empty string.
 * @providedPropType {array.<{isRefined: boolean, label: string, value: string, isRefined: boolean, noRefinement: boolean}>} items - the list of ranges the NumericMenu can display.
 */


/* harmony default export */ var connectNumericMenu = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaNumericMenu',
  $$type: 'ais.numericMenu',
  propTypes: {
    id: (prop_types_default()).string,
    attribute: (prop_types_default()).string.isRequired,
    items: prop_types_default().arrayOf(prop_types_default().shape({
      label: (prop_types_default()).node,
      start: (prop_types_default()).number,
      end: (prop_types_default()).number
    })).isRequired,
    transformItems: (prop_types_default()).func
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var attribute = props.attribute;
    var currentRefinement = connectNumericMenu_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var items = props.items.map(function (item) {
      var value = stringifyItem(item);
      return {
        label: item.label,
        value: value,
        isRefined: value === currentRefinement,
        noRefinement: results ? itemHasRefinement(connectNumericMenu_getId(props), results, value) : false
      };
    });
    var stats = results && results.getFacetByName(attribute) ? results.getFacetStats(attribute) : null;
    var refinedItem = (0,utils/* find */.sE)(items, function (item) {
      return item.isRefined === true;
    });

    if (!items.some(function (item) {
      return item.value === '';
    })) {
      items.push({
        value: '',
        isRefined: refinedItem === undefined,
        noRefinement: !stats,
        label: 'All'
      });
    }

    var transformedItems = props.transformItems ? props.transformItems(items) : items;
    return {
      items: transformedItems,
      currentRefinement: currentRefinement,
      canRefine: transformedItems.length > 0 && transformedItems.some(function (item) {
        return item.noRefinement === false;
      })
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return connectNumericMenu_refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    return connectNumericMenu_cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var attribute = props.attribute;

    var _parseItem = parseItem(connectNumericMenu_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    })),
        start = _parseItem.start,
        end = _parseItem.end;

    searchParameters = searchParameters.addDisjunctiveFacet(attribute);

    if (typeof start === 'number') {
      searchParameters = searchParameters.addNumericRefinement(attribute, '>=', start);
    }

    if (typeof end === 'number') {
      searchParameters = searchParameters.addNumericRefinement(attribute, '<=', end);
    }

    return searchParameters;
  },
  getMetadata: function getMetadata(props, searchState) {
    var id = connectNumericMenu_getId(props);
    var value = connectNumericMenu_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var items = [];
    var index = (0,indexUtils/* getIndexId */.WN)({
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (value !== '') {
      var _find = (0,utils/* find */.sE)(props.items, function (item) {
        return stringifyItem(item) === value;
      }),
          label = _find.label;

      items.push({
        label: "".concat(props.attribute, ": ").concat(label),
        attribute: props.attribute,
        currentRefinement: label,
        value: function value(nextState) {
          return connectNumericMenu_refine(props, nextState, '', {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
          });
        }
      });
    }

    return {
      id: id,
      index: index,
      items: items
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectPagination.js




function connectPagination_getId() {
  return 'page';
}

function connectPagination_getCurrentRefinement(props, searchState, context) {
  var id = connectPagination_getId();
  var page = 1;
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, id, page);

  if (typeof currentRefinement === 'string') {
    return parseInt(currentRefinement, 10);
  }

  return currentRefinement;
}

function connectPagination_refine(props, searchState, nextPage, context) {
  var id = connectPagination_getId();

  var nextValue = (0,defineProperty/* default */.Z)({}, id, nextPage);

  var resetPage = false;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage);
}
/**
 * connectPagination connector provides the logic to build a widget that will
 * let the user displays hits corresponding to a certain page.
 * @name connectPagination
 * @kind connector
 * @propType {boolean} [showFirst=true] - Display the first page link.
 * @propType {boolean} [showLast=false] - Display the last page link.
 * @propType {boolean} [showPrevious=true] - Display the previous page link.
 * @propType {boolean} [showNext=true] - Display the next page link.
 * @propType {number} [padding=3] - How many page links to display around the current page.
 * @propType {number} [totalPages=Infinity] - Maximum number of pages to display.
 * @providedPropType {function} refine - a function to remove a single filter
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {number} nbPages - the total of existing pages
 * @providedPropType {number} currentRefinement - the page refinement currently applied
 */


/* harmony default export */ var connectPagination = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaPagination',
  $$type: 'ais.pagination',
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (!results) {
      return null;
    }

    var nbPages = results.nbPages;
    return {
      nbPages: nbPages,
      currentRefinement: connectPagination_getCurrentRefinement(props, searchState, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      canRefine: nbPages > 1
    };
  },
  refine: function refine(props, searchState, nextPage) {
    return connectPagination_refine(props, searchState, nextPage, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    return (0,indexUtils/* cleanUpValue */.cI)(searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, connectPagination_getId());
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setPage(connectPagination_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }) - 1);
  },
  getMetadata: function getMetadata() {
    return {
      id: connectPagination_getId()
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectPoweredBy.js

/**
 * connectPoweredBy connector provides the logic to build a widget that
 * will display a link to algolia.
 * @name connectPoweredBy
 * @kind connector
 * @providedPropType {string} url - the url to redirect to algolia
 */

/* harmony default export */ var connectPoweredBy = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaPoweredBy',
  $$type: 'ais.poweredBy',
  getProvidedProps: function getProvidedProps() {
    var hostname = typeof window === 'undefined' || typeof window.location === 'undefined' ? '' : window.location.hostname;
    var url = 'https://www.algolia.com/?' + 'utm_source=react-instantsearch&' + 'utm_medium=website&' + "utm_content=".concat(hostname, "&") + 'utm_campaign=poweredby';
    return {
      url: url
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectRange.js




/**
 * connectRange connector provides the logic to create connected
 * components that will give the ability for a user to refine results using
 * a numeric range.
 * @name connectRange
 * @kind connector
 * @requirements The attribute passed to the `attribute` prop must be present in “attributes for faceting”
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 * The values inside the attribute must be JavaScript numbers (not strings).
 * @propType {string} attribute - Name of the attribute for faceting
 * @propType {{min?: number, max?: number}} [defaultRefinement] - Default searchState of the widget containing the start and the end of the range.
 * @propType {number} [min] - Minimum value. When this isn't set, the minimum value will be automatically computed by Algolia using the data in the index.
 * @propType {number} [max] - Maximum value. When this isn't set, the maximum value will be automatically computed by Algolia using the data in the index.
 * @propType {number} [precision=0] - Number of digits after decimal point to use.
 * @providedPropType {function} refine - a function to select a range.
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the refinement currently applied
 * @providedPropType {number} min - the minimum value available.
 * @providedPropType {number} max - the maximum value available.
 * @providedPropType {number} precision - Number of digits after decimal point to use.
 */

function connectRange_getId(props) {
  return props.attribute;
}

var connectRange_namespace = 'range';

function getCurrentRange(boundaries, stats, precision) {
  var pow = Math.pow(10, precision);
  var min;

  if (typeof boundaries.min === 'number' && isFinite(boundaries.min)) {
    min = boundaries.min;
  } else if (typeof stats.min === 'number' && isFinite(stats.min)) {
    min = stats.min;
  } else {
    min = undefined;
  }

  var max;

  if (typeof boundaries.max === 'number' && isFinite(boundaries.max)) {
    max = boundaries.max;
  } else if (typeof stats.max === 'number' && isFinite(stats.max)) {
    max = stats.max;
  } else {
    max = undefined;
  }

  return {
    min: min !== undefined ? Math.floor(min * pow) / pow : min,
    max: max !== undefined ? Math.ceil(max * pow) / pow : max
  };
}

function connectRange_getCurrentRefinement(props, searchState, currentRange, context) {
  var _getCurrentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, "".concat(connectRange_namespace, ".").concat(connectRange_getId(props)), {}),
      min = _getCurrentRefinement.min,
      max = _getCurrentRefinement.max;

  var isFloatPrecision = Boolean(props.precision);
  var nextMin = min;

  if (typeof nextMin === 'string') {
    nextMin = isFloatPrecision ? parseFloat(nextMin) : parseInt(nextMin, 10);
  }

  var nextMax = max;

  if (typeof nextMax === 'string') {
    nextMax = isFloatPrecision ? parseFloat(nextMax) : parseInt(nextMax, 10);
  }

  var refinement = {
    min: nextMin,
    max: nextMax
  };
  var hasMinBound = props.min !== undefined;
  var hasMaxBound = props.max !== undefined;
  var hasMinRefinment = refinement.min !== undefined;
  var hasMaxRefinment = refinement.max !== undefined;

  if (hasMinBound && hasMinRefinment && refinement.min < currentRange.min) {
    throw Error("You can't provide min value lower than range.");
  }

  if (hasMaxBound && hasMaxRefinment && refinement.max > currentRange.max) {
    throw Error("You can't provide max value greater than range.");
  }

  if (hasMinBound && !hasMinRefinment) {
    refinement.min = currentRange.min;
  }

  if (hasMaxBound && !hasMaxRefinment) {
    refinement.max = currentRange.max;
  }

  return refinement;
}

function getCurrentRefinementWithRange(refinement, range) {
  return {
    min: refinement.min !== undefined ? refinement.min : range.min,
    max: refinement.max !== undefined ? refinement.max : range.max
  };
}

function nextValueForRefinement(hasBound, isReset, range, value) {
  var next;

  if (!hasBound && range === value) {
    next = undefined;
  } else if (hasBound && isReset) {
    next = range;
  } else {
    next = value;
  }

  return next;
}

function connectRange_refine(props, searchState, nextRefinement, currentRange, context) {
  var nextMin = nextRefinement.min,
      nextMax = nextRefinement.max;
  var currentMinRange = currentRange.min,
      currentMaxRange = currentRange.max;
  var isMinReset = nextMin === undefined || nextMin === '';
  var isMaxReset = nextMax === undefined || nextMax === '';
  var nextMinAsNumber = !isMinReset ? parseFloat(nextMin) : undefined;
  var nextMaxAsNumber = !isMaxReset ? parseFloat(nextMax) : undefined;
  var isNextMinValid = isMinReset || isFinite(nextMinAsNumber);
  var isNextMaxValid = isMaxReset || isFinite(nextMaxAsNumber);

  if (!isNextMinValid || !isNextMaxValid) {
    throw Error("You can't provide non finite values to the range connector.");
  }

  if (nextMinAsNumber < currentMinRange) {
    throw Error("You can't provide min value lower than range.");
  }

  if (nextMaxAsNumber > currentMaxRange) {
    throw Error("You can't provide max value greater than range.");
  }

  var id = connectRange_getId(props);
  var resetPage = true;

  var nextValue = (0,defineProperty/* default */.Z)({}, id, {
    min: nextValueForRefinement(props.min !== undefined, isMinReset, currentMinRange, nextMinAsNumber),
    max: nextValueForRefinement(props.max !== undefined, isMaxReset, currentMaxRange, nextMaxAsNumber)
  });

  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage, connectRange_namespace);
}

function connectRange_cleanUp(props, searchState, context) {
  return (0,indexUtils/* cleanUpValue */.cI)(searchState, context, "".concat(connectRange_namespace, ".").concat(connectRange_getId(props)));
}

/* harmony default export */ var connectRange = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaRange',
  $$type: 'ais.range',
  propTypes: {
    id: (prop_types_default()).string,
    attribute: (prop_types_default()).string.isRequired,
    defaultRefinement: prop_types_default().shape({
      min: (prop_types_default()).number,
      max: (prop_types_default()).number
    }),
    min: (prop_types_default()).number,
    max: (prop_types_default()).number,
    precision: (prop_types_default()).number,
    header: (prop_types_default()).node,
    footer: (prop_types_default()).node
  },
  defaultProps: {
    precision: 0
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var attribute = props.attribute,
        precision = props.precision,
        minBound = props.min,
        maxBound = props.max;
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var hasFacet = results && results.getFacetByName(attribute);
    var stats = hasFacet ? results.getFacetStats(attribute) || {} : {};
    var facetValues = hasFacet ? results.getFacetValues(attribute) : [];
    var count = facetValues.map(function (v) {
      return {
        value: v.name,
        count: v.count
      };
    });

    var _getCurrentRange = getCurrentRange({
      min: minBound,
      max: maxBound
    }, stats, precision),
        rangeMin = _getCurrentRange.min,
        rangeMax = _getCurrentRange.max; // The searchState is not always in sync with the helper state. For example
    // when we set boundaries on the first render the searchState don't have
    // the correct refinement. If this behavior change in the upcoming version
    // we could store the range inside the searchState instead of rely on `this`.


    this._currentRange = {
      min: rangeMin,
      max: rangeMax
    };
    var currentRefinement = connectRange_getCurrentRefinement(props, searchState, this._currentRange, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    return {
      min: rangeMin,
      max: rangeMax,
      canRefine: count.length > 0,
      currentRefinement: getCurrentRefinementWithRange(currentRefinement, this._currentRange),
      count: count,
      precision: precision
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return connectRange_refine(props, searchState, nextRefinement, this._currentRange, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    return connectRange_cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(params, props, searchState) {
    var attribute = props.attribute;

    var _getCurrentRefinement2 = connectRange_getCurrentRefinement(props, searchState, this._currentRange, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }),
        min = _getCurrentRefinement2.min,
        max = _getCurrentRefinement2.max;

    params = params.addDisjunctiveFacet(attribute);

    if (min !== undefined) {
      params = params.addNumericRefinement(attribute, '>=', min);
    }

    if (max !== undefined) {
      params = params.addNumericRefinement(attribute, '<=', max);
    }

    return params;
  },
  getMetadata: function getMetadata(props, searchState) {
    var _this = this;

    var _this$_currentRange = this._currentRange,
        minRange = _this$_currentRange.min,
        maxRange = _this$_currentRange.max;

    var _getCurrentRefinement3 = connectRange_getCurrentRefinement(props, searchState, this._currentRange, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }),
        minValue = _getCurrentRefinement3.min,
        maxValue = _getCurrentRefinement3.max;

    var items = [];
    var hasMin = minValue !== undefined;
    var hasMax = maxValue !== undefined;
    var shouldDisplayMinLabel = hasMin && minValue !== minRange;
    var shouldDisplayMaxLabel = hasMax && maxValue !== maxRange;

    if (shouldDisplayMinLabel || shouldDisplayMaxLabel) {
      var fragments = [hasMin ? "".concat(minValue, " <= ") : '', props.attribute, hasMax ? " <= ".concat(maxValue) : ''];
      items.push({
        label: fragments.join(''),
        attribute: props.attribute,
        value: function value(nextState) {
          return connectRange_refine(props, nextState, {}, _this._currentRange, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
          });
        },
        currentRefinement: getCurrentRefinementWithRange({
          min: minValue,
          max: maxValue
        }, {
          min: minRange,
          max: maxRange
        })
      });
    }

    return {
      id: connectRange_getId(props),
      index: (0,indexUtils/* getIndexId */.WN)({
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      items: items
    };
  }
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectRefinementList.js
var connectRefinementList = __webpack_require__(93977);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectScrollTo.js




/**
 * connectScrollTo connector provides the logic to build a widget that will
 * let the page scroll to a certain point.
 * @name connectScrollTo
 * @kind connector
 * @propType {string} [scrollOn="page"] - Widget searchState key on which to listen for changes, default to the pagination widget.
 * @providedPropType {any} value - the current refinement applied to the widget listened by scrollTo
 * @providedPropType {boolean} hasNotChanged - indicates whether the refinement came from the scrollOn argument (for instance page by default)
 */

/* harmony default export */ var connectScrollTo = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaScrollTo',
  $$type: 'ais.scrollTo',
  propTypes: {
    scrollOn: (prop_types_default()).string
  },
  defaultProps: {
    scrollOn: 'page'
  },
  getProvidedProps: function getProvidedProps(props, searchState) {
    var id = props.scrollOn;
    var value = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, id, null);

    if (!this._prevSearchState) {
      this._prevSearchState = {};
    } // Get the subpart of the state that interest us


    if ((0,indexUtils/* hasMultipleIndices */.Ei)({
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    })) {
      searchState = searchState.indices ? searchState.indices[(0,indexUtils/* getIndexId */.WN)({
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      })] : {};
    } // if there is a change in the app that has been triggered by another element
    // than "props.scrollOn (id) or the Configure widget, we need to keep track of
    // the search state to know if there's a change in the app that was not triggered
    // by the props.scrollOn (id) or the Configure widget. This is useful when
    // using ScrollTo in combination of Pagination. As pagination can be change
    // by every widget, we want to scroll only if it cames from the pagination
    // widget itself. We also remove the configure key from the search state to
    // do this comparison because for now configure values are not present in the
    // search state before a first refinement has been made and will false the results.
    // See: https://github.com/algolia/react-instantsearch/issues/164


    var cleanedSearchState = (0,utils/* omit */.CE)(searchState, ['configure', id]);
    var hasNotChanged = (0,utils/* shallowEqual */.wU)(this._prevSearchState, cleanedSearchState);
    this._prevSearchState = cleanedSearchState;
    return {
      value: value,
      hasNotChanged: hasNotChanged
    };
  }
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(23935);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectRelevantSort.js




function connectRelevantSort_getId() {
  return 'relevancyStrictness';
}

function connectRelevantSort_getCurrentRefinement(props, searchState, context) {
  var id = connectRelevantSort_getId();
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, id);
  return currentRefinement;
}

/* harmony default export */ var connectRelevantSort = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaRelevantSort',
  $$type: 'ais.relevantSort',
  getProvidedProps: function getProvidedProps(props, _searchState, searchResults) {
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (!results) {
      return {
        isVirtualReplica: false,
        isRelevantSorted: false
      };
    }

    return {
      isVirtualReplica: results.appliedRelevancyStrictness !== undefined,
      isRelevantSorted: results.appliedRelevancyStrictness !== undefined && results.appliedRelevancyStrictness > 0
    };
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setQueryParameter('relevancyStrictness', connectRelevantSort_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }));
  },
  refine: function refine(props, searchState, nextRefinement) {
    var nextValue = (0,defineProperty/* default */.Z)({}, connectRelevantSort_getId(), nextRefinement);

    var resetPage = true;
    return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, resetPage);
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectSortBy.js


function connectSortBy_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function connectSortBy_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? connectSortBy_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : connectSortBy_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function connectSortBy_getId() {
  return 'sortBy';
}

function connectSortBy_getCurrentRefinement(props, searchState, context) {
  var id = connectSortBy_getId(props);
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, id, null);

  if (currentRefinement) {
    return currentRefinement;
  }

  return null;
}
/**
 * The connectSortBy connector provides the logic to build a widget that will
 *  display a list of indices. This allows a user to change how the hits are being sorted.
 * @name connectSortBy
 * @requirements Algolia handles sorting by creating replica indices. [Read more about sorting](https://www.algolia.com/doc/guides/relevance/sorting/) on
 * the Algolia website.
 * @kind connector
 * @propType {string} defaultRefinement - The default selected index.
 * @propType {{value: string, label: string}[]} items - The list of indexes to search in.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to remove a single filter
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string[]} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{isRefined: boolean, label?: string, value: string}>} items - the list of items the HitsPerPage can display.  If no label provided, the value will be displayed.
 */


/* harmony default export */ var connectSortBy = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaSortBy',
  $$type: 'ais.sortBy',
  propTypes: {
    defaultRefinement: (prop_types_default()).string,
    items: prop_types_default().arrayOf(prop_types_default().shape({
      label: (prop_types_default()).string,
      value: (prop_types_default()).string.isRequired
    })).isRequired,
    transformItems: (prop_types_default()).func
  },
  getProvidedProps: function getProvidedProps(props, searchState) {
    var currentRefinement = connectSortBy_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var items = props.items.map(function (item) {
      return item.value === currentRefinement ? connectSortBy_objectSpread(connectSortBy_objectSpread({}, item), {}, {
        isRefined: true
      }) : connectSortBy_objectSpread(connectSortBy_objectSpread({}, item), {}, {
        isRefined: false
      });
    });
    return {
      items: props.transformItems ? props.transformItems(items) : items,
      currentRefinement: currentRefinement
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    var id = connectSortBy_getId();

    var nextValue = (0,defineProperty/* default */.Z)({}, id, nextRefinement);

    var resetPage = true;
    return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, resetPage);
  },
  cleanUp: function cleanUp(props, searchState) {
    return (0,indexUtils/* cleanUpValue */.cI)(searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    }, connectSortBy_getId());
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var selectedIndex = connectSortBy_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    return searchParameters.setIndex(selectedIndex);
  },
  getMetadata: function getMetadata() {
    return {
      id: connectSortBy_getId()
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectStateResults.js


/**
 * The `connectStateResults` connector provides a way to access the `searchState` and the `searchResults`
 * of InstantSearch.
 * For instance this connector allows you to create results/noResults or query/noQuery pages.
 * @name connectStateResults
 * @kind connector
 * @providedPropType {object} searchState - The search state of the instant search component. <br/><br/> See: [Search state structure](https://community.algolia.com/react-instantsearch/guide/Search_state.html)
 * @providedPropType {object} searchResults - The search results. <br/><br/> In case of multiple indices: if used under `<Index>`, results will be those of the corresponding index otherwise it'll be those of the root index  See: [Search results structure](https://community.algolia.com/algoliasearch-helper-js/reference.html#searchresults)
 * @providedPropType {object} allSearchResults - In case of multiple indices you can retrieve all the results
 * @providedPropType {string} error - If the search failed, the error will be logged here.
 * @providedPropType {boolean} searching - If there is a search in progress.
 * @providedPropType {boolean} isSearchStalled - Flag that indicates if React InstantSearch has detected that searches are stalled.
 * @providedPropType {boolean} searchingForFacetValues - If there is a search in a list in progress.
 * @providedPropType {object} props - component props.
 * @example
 * import React from 'react';
 * import algoliasearch from 'algoliasearch/lite';
 * import { InstantSearch, SearchBox, Hits, connectStateResults } from 'react-instantsearch-dom';
 *
 * const searchClient = algoliasearch(
 *   'latency',
 *   '6be0576ff61c053d5f9a3225e2a90f76'
 * );
 *
 * const Content = connectStateResults(({ searchState, searchResults }) => {
 *   const hasResults = searchResults && searchResults.nbHits !== 0;
 *
 *    return (
 *      <div>
 *        <div hidden={!hasResults}>
 *          <Hits />
 *        </div>
 *        <div hidden={hasResults}>
 *          <div>No results has been found for {searchState.query}</div>
 *        </div>
 *      </div>
 *    );
 * });
 *
 * const App = () => (
 *   <InstantSearch
 *      searchClient={searchClient}
 *      indexName="instant_search"
 *    >
 *      <SearchBox />
 *      <Content />
 *    </InstantSearch>
 * );
 */

/* harmony default export */ var connectStateResults = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaStateResults',
  $$type: 'ais.stateResults',
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    return {
      searchState: searchState,
      searchResults: results,
      allSearchResults: searchResults.results,
      searching: searchResults.searching,
      isSearchStalled: searchResults.isSearchStalled,
      error: searchResults.error,
      searchingForFacetValues: searchResults.searchingForFacetValues,
      props: props
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectStats.js


/**
 * connectStats connector provides the logic to build a widget that will
 *  displays algolia search statistics (hits number and processing time).
 * @name connectStats
 * @kind connector
 * @providedPropType {number} nbHits - number of hits returned by Algolia.
 * @providedPropType {number} nbSortedHits - number of sorted hits returned by Algolia.
 * @providedPropType {number} processingTimeMS - the time in ms took by Algolia to search for results.
 */

/* harmony default export */ var connectStats = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaStats',
  $$type: 'ais.stats',
  getProvidedProps: function getProvidedProps(props, _searchState, searchResults) {
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (!results) {
      return null;
    }

    return {
      areHitsSorted: results.appliedRelevancyStrictness !== undefined && results.appliedRelevancyStrictness > 0 && results.nbHits !== results.nbSortedHits,
      nbHits: results.nbHits,
      nbSortedHits: results.nbSortedHits,
      processingTimeMS: results.processingTimeMS
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectToggleRefinement.js






function connectToggleRefinement_getId(props) {
  return props.attribute;
}

var connectToggleRefinement_namespace = 'toggle';
var falsyStrings = ['0', 'false', 'null', 'undefined'];

function connectToggleRefinement_getCurrentRefinement(props, searchState, context) {
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, "".concat(connectToggleRefinement_namespace, ".").concat(connectToggleRefinement_getId(props)), false);

  if (falsyStrings.indexOf(currentRefinement) !== -1) {
    return false;
  }

  return Boolean(currentRefinement);
}

function connectToggleRefinement_refine(props, searchState, nextRefinement, context) {
  var id = connectToggleRefinement_getId(props);

  var nextValue = (0,defineProperty/* default */.Z)({}, id, nextRefinement ? nextRefinement : false);

  var resetPage = true;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage, connectToggleRefinement_namespace);
}

function connectToggleRefinement_cleanUp(props, searchState, context) {
  return (0,indexUtils/* cleanUpValue */.cI)(searchState, context, "".concat(connectToggleRefinement_namespace, ".").concat(connectToggleRefinement_getId(props)));
}
/**
 * connectToggleRefinement connector provides the logic to build a widget that will
 * provides an on/off filtering feature based on an attribute value.
 * @name connectToggleRefinement
 * @kind connector
 * @requirements To use this widget, you'll need an attribute to toggle on.
 *
 * You can't toggle on null or not-null values. If you want to address this particular use-case you'll need to compute an
 * extra boolean attribute saying if the value exists or not. See this [thread](https://discourse.algolia.com/t/how-to-create-a-toggle-for-the-absence-of-a-string-attribute/2460) for more details.
 *
 * @propType {string} attribute - Name of the attribute on which to apply the `value` refinement. Required when `value` is present.
 * @propType {string} label - Label for the toggle.
 * @propType {string} value - Value of the refinement to apply on `attribute`.
 * @propType {boolean} [defaultRefinement=false] - Default searchState of the widget. Should the toggle be checked by default?
 * @providedPropType {boolean} currentRefinement - `true` when the refinement is applied, `false` otherwise
 * @providedPropType {object} count - an object that contains the count for `checked` and `unchecked` state
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 */


/* harmony default export */ var connectToggleRefinement = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaToggle',
  $$type: 'ais.toggle',
  propTypes: {
    label: (prop_types_default()).string.isRequired,
    attribute: (prop_types_default()).string.isRequired,
    value: (prop_types_default()).any.isRequired,
    filter: (prop_types_default()).func,
    defaultRefinement: (prop_types_default()).bool
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var attribute = props.attribute,
        value = props.value;
    var results = (0,indexUtils/* getResults */.O7)(searchResults, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var currentRefinement = connectToggleRefinement_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var allFacetValues = results && results.getFacetByName(attribute) ? results.getFacetValues(attribute) : null;
    var facetValue = // Use null to always be consistent with type of the value
    // count: number | null
    allFacetValues && allFacetValues.length ? (0,utils/* find */.sE)(allFacetValues, function (item) {
      return item.name === value.toString();
    }) : null;
    var facetValueCount = facetValue && facetValue.count;
    var allFacetValuesCount = // Use null to always be consistent with type of the value
    // count: number | null
    allFacetValues && allFacetValues.length ? allFacetValues.reduce(function (acc, item) {
      return acc + item.count;
    }, 0) : null;
    var canRefine = currentRefinement ? allFacetValuesCount !== null && allFacetValuesCount > 0 : facetValueCount !== null && facetValueCount > 0;
    var count = {
      checked: allFacetValuesCount,
      unchecked: facetValueCount
    };
    return {
      currentRefinement: currentRefinement,
      canRefine: canRefine,
      count: count
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return connectToggleRefinement_refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    return connectToggleRefinement_cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var attribute = props.attribute,
        value = props.value,
        filter = props.filter;
    var checked = connectToggleRefinement_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var nextSearchParameters = searchParameters.addDisjunctiveFacet(attribute);

    if (checked) {
      nextSearchParameters = nextSearchParameters.addDisjunctiveFacetRefinement(attribute, value);

      if (filter) {
        nextSearchParameters = filter(nextSearchParameters);
      }
    }

    return nextSearchParameters;
  },
  getMetadata: function getMetadata(props, searchState) {
    var id = connectToggleRefinement_getId(props);
    var checked = connectToggleRefinement_getCurrentRefinement(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var items = [];
    var index = (0,indexUtils/* getIndexId */.WN)({
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });

    if (checked) {
      items.push({
        label: props.label,
        currentRefinement: checked,
        attribute: props.attribute,
        value: function value(nextState) {
          return connectToggleRefinement_refine(props, nextState, false, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
          });
        }
      });
    }

    return {
      id: id,
      index: index,
      items: items
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectHitInsights.js


function connectHitInsights_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function connectHitInsights_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? connectHitInsights_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : connectHitInsights_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function inferPayload(_ref) {
  var method = _ref.method,
      results = _ref.results,
      currentHit = _ref.currentHit;
  var index = results.index;
  var queryID = currentHit.__queryID;
  var objectIDs = [currentHit.objectID];

  if (!queryID) {
    throw new Error("Could not infer `queryID`. Ensure `clickAnalytics: true` was added with the Configure widget.\nSee: https://alg.li/VpPpLt");
  }

  switch (method) {
    case 'clickedObjectIDsAfterSearch':
      {
        var positions = [currentHit.__position];
        return {
          index: index,
          queryID: queryID,
          objectIDs: objectIDs,
          positions: positions
        };
      }

    case 'convertedObjectIDsAfterSearch':
      return {
        index: index,
        queryID: queryID,
        objectIDs: objectIDs
      };

    default:
      throw new Error("Unsupported method \"".concat(method, "\" passed to the insights function. The supported methods are: \"clickedObjectIDsAfterSearch\", \"convertedObjectIDsAfterSearch\"."));
  }
}

var wrapInsightsClient = function wrapInsightsClient(aa, results, currentHit) {
  return function (method, payload) {
    if (typeof aa !== 'function') {
      throw new TypeError("Expected insightsClient to be a Function");
    }

    var inferredPayload = inferPayload({
      method: method,
      results: results,
      currentHit: currentHit
    });
    aa(method, connectHitInsights_objectSpread(connectHitInsights_objectSpread({}, inferredPayload), payload));
  };
};

/* harmony default export */ var connectHitInsights = (function (insightsClient) {
  return (0,createConnector/* default */.Z)({
    displayName: 'AlgoliaInsights',
    $$type: 'ais.insights',
    getProvidedProps: function getProvidedProps(props, _, searchResults) {
      var results = (0,indexUtils/* getResults */.O7)(searchResults, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      });
      var insights = wrapInsightsClient(insightsClient, results, props.hit);
      return {
        insights: insights
      };
    }
  });
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectVoiceSearch.js


function connectVoiceSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function connectVoiceSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? connectVoiceSearch_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : connectVoiceSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function connectVoiceSearch_getId() {
  return 'query';
}

function getAdditionalId() {
  return 'additionalVoiceParameters';
}

function getCurrentRefinementQuery(props, searchState, context) {
  var id = connectVoiceSearch_getId();
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, id, '');

  if (currentRefinement) {
    return currentRefinement;
  }

  return '';
}

function getCurrentRefinementAdditional(props, searchState, context) {
  var id = getAdditionalId();
  var currentRefinement = (0,indexUtils/* getCurrentRefinementValue */.U6)(props, searchState, context, id, '');

  if (currentRefinement) {
    return currentRefinement;
  }

  return {};
}

function connectVoiceSearch_refine(props, searchState, nextRefinement, context) {
  var _nextValue;

  var id = connectVoiceSearch_getId();
  var voiceParams = getAdditionalId();
  var queryLanguages = props.language ? {
    queryLanguages: [props.language.split('-')[0]]
  } : {};
  var additionalQueryParameters = typeof props.additionalQueryParameters === 'function' ? connectVoiceSearch_objectSpread({
    ignorePlurals: true,
    removeStopWords: true,
    optionalWords: nextRefinement
  }, props.additionalQueryParameters({
    query: nextRefinement
  })) : {};
  var nextValue = (_nextValue = {}, (0,defineProperty/* default */.Z)(_nextValue, id, nextRefinement), (0,defineProperty/* default */.Z)(_nextValue, voiceParams, connectVoiceSearch_objectSpread(connectVoiceSearch_objectSpread({}, queryLanguages), additionalQueryParameters)), _nextValue);
  var resetPage = true;
  return (0,indexUtils/* refineValue */.RD)(searchState, nextValue, context, resetPage);
}

function connectVoiceSearch_cleanUp(props, searchState, context) {
  var interimState = (0,indexUtils/* cleanUpValue */.cI)(searchState, context, connectVoiceSearch_getId());
  return (0,indexUtils/* cleanUpValue */.cI)(interimState, context, getAdditionalId());
}

/* harmony default export */ var connectVoiceSearch = ((0,createConnector/* default */.Z)({
  displayName: 'AlgoliaVoiceSearch',
  $$type: 'ais.voiceSearch',
  propTypes: {
    defaultRefinement: (prop_types_default()).string
  },
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    return {
      currentRefinement: getCurrentRefinementQuery(props, searchState, {
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      isSearchStalled: searchResults.isSearchStalled
    };
  },
  refine: function refine(props, searchState, nextRefinement) {
    return connectVoiceSearch_refine(props, searchState, nextRefinement, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  cleanUp: function cleanUp(props, searchState) {
    return connectVoiceSearch_cleanUp(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var query = getCurrentRefinementQuery(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    var additionalParams = getCurrentRefinementAdditional(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    return searchParameters.setQuery(query).setQueryParameters(additionalParams);
  },
  getMetadata: function getMetadata(props, searchState) {
    var id = connectVoiceSearch_getId();
    var currentRefinement = getCurrentRefinementQuery(props, searchState, {
      ais: props.contextValue,
      multiIndexContext: props.indexContextValue
    });
    return {
      id: id,
      index: (0,indexUtils/* getIndexId */.WN)({
        ais: props.contextValue,
        multiIndexContext: props.indexContextValue
      }),
      items: currentRefinement === null ? [] : [{
        label: "".concat(id, ": ").concat(currentRefinement),
        value: function value(nextState) {
          return connectVoiceSearch_refine(props, nextState, '', {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
          });
        },
        currentRefinement: currentRefinement
      }]
    };
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/index.js
// Core

 // Utils



 // Widgets




/** @deprecated use DynamicWidgets */

var ExperimentalDynamicWidgets = widgets_DynamicWidgets;



 // Connectors







/** @deprecated use connectDynamicWidgets */

var EXPERIMENTAL_connectDynamicWidgets = connectDynamicWidgets;






















 // Types



/***/ }),

/***/ 42338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(99376);

var _typeof = __webpack_require__(69946);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.findResultsState = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(12095));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(94434));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44463));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(93275));

var _react = _interopRequireDefault(__webpack_require__(59496));

var _server = __webpack_require__(30999);

var _algoliasearchHelper = _interopRequireWildcard(__webpack_require__(60851));

var _reactInstantsearchCore = __webpack_require__(47726);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var hasMultipleIndices = function hasMultipleIndices(context) {
  return context && context.multiIndexContext;
};

var getIndexId = function getIndexId(context) {
  return hasMultipleIndices(context) ? context.multiIndexContext.targetedIndex : context.ais.mainTargetedIndex;
};

function createWidgetsCollector(accumulator) {
  return function (props) {
    accumulator.push(_objectSpread(_objectSpread({}, props), {}, {
      index: getIndexId(props.context)
    }));
  };
}

function getMetadata(widgets) {
  return widgets.filter(function (widget) {
    return widget.getMetadata;
  }).map(function (widget) {
    return widget.getMetadata(widget.props, widget.searchState);
  });
}

var getSearchParameters = function getSearchParameters(indexName, widgets) {
  var sharedParameters = widgets.filter(function (widget) {
    return !hasMultipleIndices(widget.context);
  }).reduce(function (acc, widget) {
    return widget.getSearchParameters(acc, widget.props, widget.searchState);
  }, new _algoliasearchHelper.default.SearchParameters(_objectSpread(_objectSpread({}, _reactInstantsearchCore.HIGHLIGHT_TAGS), {}, {
    index: indexName
  })));
  var derivedParameters = widgets.filter(function (widget) {
    return hasMultipleIndices(widget.context);
  }).reduce(function (acc, widget) {
    var indexId = getIndexId(widget.context);
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, indexId, widget.getSearchParameters(acc[indexId] || sharedParameters, widget.props, widget.searchState)));
  }, {});
  return {
    sharedParameters: sharedParameters,
    derivedParameters: derivedParameters
  };
};
/**
 * The engine can return params: "query=xxx&query=yyy" if e.g. a query rule modifies it.
 * This however will cause us to miss the cache hydration, so we make sure to keep
 * only the first query (always the one from the parameters).
 */


function removeDuplicateQuery(params) {
  if (!params) {
    return params;
  }

  var hasFoundQuery = false;
  var queryParamRegex = /&?query=[^&]*/g;
  return params.replace(queryParamRegex, function replacer(match) {
    if (hasFoundQuery) {
      return '';
    }

    hasFoundQuery = true;
    return match;
  });
}

function cleanRawResults(rawResults) {
  return rawResults.map(function (res) {
    return _objectSpread(_objectSpread({}, res), {}, {
      params: removeDuplicateQuery(res.params)
    });
  });
}

var singleIndexSearch = function singleIndexSearch(helper, parameters) {
  return helper.searchOnce(parameters).then(function (res) {
    return {
      rawResults: cleanRawResults(res.content._rawResults),
      state: res.content._state
    };
  });
};

var multiIndexSearch = function multiIndexSearch(indexName, client, sharedParameters, _ref) {
  var mainParameters = _ref[indexName],
      derivedParameters = (0, _objectWithoutProperties2.default)(_ref, [indexName].map(_toPropertyKey));
  var helper = (0, _algoliasearchHelper.default)(client, indexName);
  var indexIds = Object.keys(derivedParameters);
  var searches = [new _algoliasearchHelper.SearchParameters(_objectSpread(_objectSpread({}, sharedParameters), mainParameters))].concat((0, _toConsumableArray2.default)(indexIds.map(function (indexId) {
    return derivedParameters[indexId];
  }))).map(function (params) {
    return new Promise(function (resolve) {
      return helper.derive(function () {
        return params;
      }).once('result', resolve);
    });
  });
  helper.searchOnlyWithDerivedHelpers(); // We attach `indexId` on the results to be able to reconstruct the object
  // on the client side. We cannot rely on `state.index` anymore because we
  // may have multiple times the same index.

  return Promise.all(searches).then(function (results) {
    return [indexName].concat((0, _toConsumableArray2.default)(indexIds)).map(function (indexId, i) {
      return {
        rawResults: cleanRawResults(results[i].results._rawResults),
        state: results[i].results._state,
        _internalIndexId: indexId
      };
    });
  });
};

var findResultsState = function findResultsState(App, props) {
  if (!props) {
    throw new Error('The function `findResultsState` must be called with props: `findResultsState(App, props)`');
  }

  if (!props.searchClient) {
    throw new Error('The props provided to `findResultsState` must have a `searchClient`');
  }

  if (!props.indexName) {
    throw new Error('The props provided to `findResultsState` must have an `indexName`');
  }

  var widgets = []; // eslint-disable-next-line no-shadow

  function execute(props) {
    widgets = [];
    (0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(App, (0, _extends2.default)({}, props, {
      widgetsCollector: createWidgetsCollector(widgets)
    })));

    if (widgets.length === 0) {
      throw new Error('[ssr]: no widgets were added, you likely did not pass the `widgetsCollector` down to the InstantSearch component.');
    }

    var _getSearchParameters = getSearchParameters(props.indexName, widgets),
        sharedParameters = _getSearchParameters.sharedParameters,
        derivedParameters = _getSearchParameters.derivedParameters;

    var metadata = getMetadata(widgets);
    var helper = (0, _algoliasearchHelper.default)(props.searchClient, sharedParameters.index);

    if (typeof props.searchClient.addAlgoliaAgent === 'function') {
      props.searchClient.addAlgoliaAgent("react-instantsearch-server (".concat(_reactInstantsearchCore.version, ")"));
    }

    if (Object.keys(derivedParameters).length === 0) {
      return singleIndexSearch(helper, sharedParameters).then(function (res) {
        return _objectSpread({
          metadata: metadata
        }, res);
      });
    }

    return multiIndexSearch(props.indexName, props.searchClient, sharedParameters, derivedParameters).then(function (results) {
      return {
        metadata: metadata,
        results: results
      };
    });
  }

  return execute(props).then(function (resultsState) {
    // <DynamicWidgets> requires another query to retrieve the dynamic widgets
    // to render.
    if (widgets.some(function (widget) {
      return widget.displayName === 'AlgoliaDynamicWidgets';
    })) {
      return execute(_objectSpread(_objectSpread({}, props), {}, {
        resultsState: resultsState
      }));
    }

    return resultsState;
  });
};

exports.findResultsState = findResultsState;

/***/ }),

/***/ 8933:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "findResultsState", ({
  enumerable: true,
  get: function get() {
    return _createInstantSearchServer.findResultsState;
  }
}));

var _createInstantSearchServer = __webpack_require__(42338);

/***/ }),

/***/ 46514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable import/no-commonjs, no-var */

// This file only exist to allow the import from 'react-instantsearch-dom/server'
// We can't have this import working easily with the current project architecture.
// The main reason is that we require to have the files transpiled at development
// time to allow the import accross Workspaces (node_modules are not transpiled).
// To achieve this we scope all the packages artefacts in the `dist` folder under
// `/cjs` & `/es`. At the end we can require the package as it is with a `main`
// that point to `./dist/cjs/index.js` & `module` that point to the `es` folder.
// But the `/server` import will fallback into this file instead of the correct
// one the `dist` folder.
// We now have the solution for those use cases: private packages. You can have
// nested private packages inside your "main" package. The advantage of this
// approach is to leverage the module resolution of npm. A popular package built
// with this approach is Preact 10.x.x: https://bit.ly/2WrMjLF

var server = __webpack_require__(8933);

module.exports = server;


/***/ }),

/***/ 33737:
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 13989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(33737);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93275:
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 56037:
/***/ (function(module) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 90623:
/***/ (function(module) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 44463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(99893);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 99893:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 94434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(13989);

var iterableToArray = __webpack_require__(56037);

var unsupportedIterableToArray = __webpack_require__(94945);

var nonIterableSpread = __webpack_require__(90623);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69946:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 94945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(33737);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

}]);